import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../css/svg.css';

const CountryMap = ({ onRegionClick }) => {
	const [selectedRegion, setSelectedRegion] = useState(null);
	const [isVisible, setIsVisible] = useState(true);

	const handleRegionClick = (regionId) => {
		setSelectedRegion(regionId);
		setIsVisible(false);
		setTimeout(() => {
			onRegionClick(regionId);
		}, 500);
		console.log('Region Clicked: %s', regionId);
	};

	return (
		<svg
			id='country-map'
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 7500 4800'
			className='map'>
			<polygon
				id='northeast'
				points='5873.45 1616.62 5942.13 2022.78 6264.05 1962.35 6354.14 1943.67 6460.71 1922.79 6537.62 1904.12 6571.68 1898.62 6580.47 1873.35 6607.94 1861.27 6615.63 1877.75 6607.94 1894.23 6609.04 1912.91 6622.22 1934.88 6642 1949.16 6660.68 1961.25 6685.95 1966.74 6710.12 1965.64 6712.31 2006.3 6724.4 2005.2 6733.19 1978.67 6743.08 1951.36 6749.67 1927.19 6767.25 1896.43 6784.83 1849.18 6793.62 1819.52 6793.62 1759.61 6784.83 1721.73 6740.88 1719.54 6740.88 1686.58 6754.06 1665.7 6765.05 1655.81 6769.45 1659.11 6772.74 1681.08 6787.03 1687.68 6815.59 1673.39 6887.01 1633.84 6932.05 1612.96 6956.22 1596.48 6990.28 1562.42 6959.52 1549.24 6927.66 1571.21 6904.59 1583.3 6873.82 1593.19 6843.06 1611.87 6805.7 1626.15 6787.03 1637.14 6782.63 1631.64 6795.82 1606.37 6818.89 1588.79 6867.23 1549.24 6925.46 1522.87 7007.86 1498.24 7040.82 1477.83 7061.7 1461.35 7061.7 1429.28 7051.81 1413 7061.7 1387.55 7081.47 1405.31 7100.15 1415.2 7100.15 1432.18 7115.53 1423.99 7128.72 1400.92 7143 1380.04 7153.99 1386.63 7153.99 1408.99 7166.07 1409.71 7194.64 1389.93 7221.01 1375.65 7241.88 1360.27 7241.88 1333.66 7232 1318.52 7210.02 1304.23 7185.85 1298.74 7206.73 1314.12 7224.3 1326.21 7226.5 1342.69 7212.22 1356.97 7185.85 1365.76 7164.97 1355.87 7149.59 1339.39 7133.11 1329.5 7132.01 1308.63 7110.04 1293.25 7075.49 1293.25 7073.78 1269.07 7090.26 1244.9 7110.04 1226.23 7086.97 1216.34 7075.98 1194.36 7075.98 1152.61 7084.77 1119.65 7096.86 1080.1 7107.84 1026.26 7121.03 994.4 7135.31 1002.09 7156.62 994.4 7182.55 979.02 7189.15 963.64 7191.34 939.47 7224.42 939.47 7226.5 849.37 7236.39 830.7 7250.5 830.7 7256.17 839.49 7256.17 863.66 7286.93 863.66 7286.93 837.58 7303.41 819.71 7340.77 812.02 7374.82 776.86 7409.98 755.99 7434.15 729.62 7436.35 710.94 7419.87 706.55 7418.77 671.39 7396.8 659.3 7367.13 666.99 7355.05 635.13 7351.75 597.77 7310.2 597.77 7294.62 585.69 7288.03 546.14 7257.26 458.24 7233.09 384.63 7217.71 359.36 7197.94 352.77 7180.36 337.39 7159.48 329.69 7138.61 341.78 7115.53 363.75 7094.66 378.04 7075.98 379.14 7067.19 364.85 7057.3 345.08 7037.53 349.47 7017.75 406.6 7005.66 445.06 6996.88 474.72 6988.09 497.79 6993.58 529.66 6994.68 553.83 6984.79 581.29 6984.79 657.1 6980.4 683.47 6968.31 703.25 6956.22 723.03 6956.22 751.59 6949.63 766.97 6929.86 773.57 6917.77 784.55 6891.4 791.14 6888.11 847.18 6819.99 860.36 6745.28 881.24 6657.38 903.21 6560.7 928.48 6477.2 950.45 6437.64 977.92 6404.68 1027.36 6388.2 1062.52 6379.41 1087.79 6338.76 1132.84 6339.86 1149.32 6353.04 1180.08 6364.03 1199.86 6361.83 1227.32 6337.66 1260.28 6308 1293.25 6272.84 1310.82 6250.86 1315.22 6142.09 1315.22 6084.96 1329.5 6045.41 1343.79 6025.63 1362.46 6026.73 1382.24 6042.11 1397.62 6054.2 1413 6054.2 1445.96 6025.63 1482.22 5994.87 1519.58 5969.6 1542.65 5910.27 1593.19 5873.45 1616.62'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='northeast'
				className={`polygon ${selectedRegion === 'northeast' ? 'selected' : ''}`}
				onClick={() => handleRegionClick('northeast')}
			/>
			<polygon
				id='southeast'
				points='6607.94 1861.27 6615.63 1877.75 6607.94 1894.23 6609.04 1912.91 6622.22 1934.88 6639.8 1967.84 6651.89 1995.31 6670.56 2022.78 6698.03 2037.06 6707.92 2057.93 6714.51 2091.99 6712.31 2122.76 6702.43 2168.9 6690.34 2198.57 6680.45 2257.9 6667.27 2307.34 6646.39 2354.58 6643.1 2344.69 6643.1 2294.15 6649.69 2261.19 6650.79 2230.43 6650.79 2206.26 6635.41 2205.16 6635.41 2180.99 6631.01 2166.7 6615.63 2154.62 6593.66 2145.83 6560.7 2143.63 6560.7 2112.87 6553 2097.49 6545.31 2076.61 6538.72 2057.93 6540.92 2007.39 6546.41 1988.72 6547.51 1953.56 6539.82 1949.16 6529.93 1962.35 6514.55 1985.42 6500.27 2012.89 6500.27 2055.74 6504.66 2081.01 6521.14 2118.36 6538.72 2145.83 6551.91 2170 6556.3 2191.97 6543.12 2186.48 6521.14 2175.49 6495.87 2164.51 6460.71 2160.11 6431.05 2156.82 6429.95 2121.66 6415.67 2138.14 6409.08 2168.9 6423.36 2187.58 6442.06 2175.49 6458.52 2175.49 6481.59 2193.07 6522.24 2199.66 6546.41 2217.24 6573.88 2224.93 6578.27 2251.3 6577.18 2282.07 6598.05 2302.94 6598.05 2322.72 6581.57 2335.9 6595.85 2360.07 6616.73 2390.84 6648.59 2429.29 6665.07 2463.35 6694.74 2497.41 6702.41 2524.88 6677.16 2524.88 6642 2543.55 6626.79 2557.84 6603.54 2563.33 6609.04 2574.32 6637.6 2576.52 6662.87 2561.13 6715.61 2561.13 6733.19 2577.32 6733.19 2610.57 6727.7 2627.06 6712.31 2653.42 6682.65 2673.2 6639.08 2673.2 6639.8 2691.88 6646.39 2702.86 6642 2725.94 6635.41 2744.61 6635.41 2753.4 6651.89 2743.52 6666.17 2731.43 6682.65 2733.36 6682.65 2755.6 6674.96 2774.28 6643.1 2794.06 6609.04 2807.24 6574.98 2828.12 6539.82 2857.78 6511.25 2888.54 6495.87 2917.22 6495.87 2944.58 6488.18 2967.65 6469.5 2979.73 6432.15 2989.62 6402.48 3001.71 6381.61 3022.58 6359.64 3048.95 6339.86 3087.41 6329.97 3136.85 6305.8 3175.3 6267.35 3222.55 6224.5 3263.2 6186.04 3290.66 6165.17 3298.35 6172.86 3309.34 6177.25 3323.62 6162.97 3337.91 6147.59 3340.1 6146.49 3353.29 6132.21 3367.57 6125.61 3389.55 6108.04 3420.31 6093.75 3462.06 6083.86 3515.9 6067.38 3556.55 6067.38 3642.24 6092.65 3697.18 6114.63 3751.01 6141 3802.65 6175.06 3860.88 6212.41 3912.52 6256.36 3959.77 6259.65 3975.15 6235.48 3971.85 6250.86 4012.5 6273.94 4056.45 6315.69 4116.88 6349.75 4174.01 6378.31 4217.96 6401.39 4258.61 6417.87 4308.05 6418.96 4345.41 6423.36 4386.06 6426.66 4427.81 6421.16 4458.57 6409.08 4482.74 6405.78 4498.9 6405.78 4546.47 6384.91 4573.93 6359.64 4592.61 6332.17 4599.2 6292.62 4599.2 6283.83 4589.32 6280.53 4564.05 6260.75 4529.99 6231.09 4492.63 6211.31 4477.25 6181.65 4477.25 6171.76 4470.66 6156.38 4450.88 6142.09 4432.83 6142.09 4410.23 6123.42 4392.65 6103.64 4371.77 6091.55 4356.33 6091.55 4338.81 6088.26 4322.33 6076.17 4311.35 6068.48 4321.23 6055.3 4326.73 6046.51 4322.33 6024.53 4300.36 5982.78 4237.73 5981.69 4221.25 5992.67 4205.87 6005.86 4179.5 6014.65 4160.83 6004.76 4152.04 5990.48 4153.14 5981.69 4165.22 5978.39 4182.8 5966.3 4191.59 5953.12 4183.9 5941.03 4174.01 5941.03 4142.15 5948.73 4116.88 5955.32 4083.92 5955.32 4016.9 5948.73 3986.13 5926.75 3959.77 5904.78 3945.48 5867.42 3927.9 5836.66 3904.83 5799.3 3863.08 5772.93 3838.91 5750.96 3818.03 5722.4 3802.65 5670.76 3802.65 5655.38 3819.13 5652.08 3841.11 5635.6 3844.4 5612.53 3858.69 5579.57 3876.27 5544.41 3887.25 5522.43 3889.45 5492.77 3852.09 5456.51 3825.73 5429.04 3809.25 5388.39 3794.96 5327.97 3792.77 5266.44 3796.06 5214.8 3812.54 5190.63 3820.23 5186.23 3797.16 5179.64 3793.86 5170.85 3808.15 5157.67 3827.92 5140.09 3840.01 5123.61 3819.13 5098.34 3800.75 5098.34 3777.38 5092.85 3766.4 5082.96 3762 5075.29 3780.47 5075.29 3823.53 5036.81 3823.53 5021.43 3830.12 4998.36 3831.22 4963.2 3827.92 4923.65 3831.22 4892.74 3844.4 4870.91 3872.97 4842.34 3872.97 4802.79 3855.39 4786.1 3844.4 4757.75 3844.4 4740.17 3852.09 4724.78 3867.48 4727.57 3886.15 4741.27 3898.24 4764.34 3902.63 4786.31 3898.24 4798.4 3891.65 4817.07 3886.15 4829.16 3896.04 4819.27 3911.42 4826.96 3920.21 4845.64 3924.61 4856.63 3915.82 4867.61 3902.63 4880.8 3908.13 4888.49 3924.61 4885.19 3941.09 4869.81 3945.48 4866.52 3965.26 4848.69 3967.46 4848.94 3986.13 4872.01 4000.42 4898.38 4011.4 4932.44 4026.79 4947.82 4046.56 4940.13 4064.14 4924.75 4067.44 4902.77 4057.55 4856.63 4031.18 4829.16 4014.7 4798.4 4000.42 4774.23 3989.43 4787.41 4010.31 4794 4025.69 4787.41 4040.68 4787.41 4061.94 4773.13 4074.03 4763.24 4068.54 4757.75 4049.86 4744.56 4046.56 4731.38 4034.48 4711.6 4053.15 4687.43 4074.03 4669.85 4074.03 4656.67 4066.34 4632.49 4053.15 4606.13 4025.69 4577.56 4009.21 4553.39 3993.83 4506.19 3967.46 4481.97 3967.46 4471.42 3976.25 4468.79 4007.01 4427.04 4008.11 4392.98 4005.91 4323.76 3987.23 4294.08 3976.25 4257.84 3976.25 4227.08 3989.43 4188.62 3996.02 4204.01 3953.17 4218.29 3924.61 4216.09 3831.22 4232.57 3790.57 4238.07 3760.9 4228.18 3720.25 4202.91 3659.82 4178.74 3609.28 4155.66 3585.11 4155.66 3404.93 4149.07 3310.44 4111.72 3309.34 4093.04 3304.95 4085.35 3295.06 4085.35 2987.43 4075.46 2898.43 4060.08 2842.4 4053.49 2807.24 4053.49 2784.43 4151.27 2784.43 4390.78 2776.48 4585.25 2763.29 4680.84 2758.9 4697.32 2774.28 4695.12 2803.94 4678.64 2820.42 4668.75 2836.9 4673.15 2847.89 4696.22 2843.5 4750.05 2844.6 4769.83 2794.06 4774.23 2760 4792.9 2728.13 4819.27 2720.44 4825.86 2684.19 4820.37 2647.93 4823.67 2622.66 4843.72 2607.83 4868.71 2617.17 4891.79 2635.84 4915.96 2630.35 4920.35 2612.77 4913.76 2601.79 4907.17 2589.7 4931.34 2565.53 4951.11 2556.74 4958.81 2539.16 4962.1 2511.69 4966.5 2497.41 5020.33 2477.63 5054.39 2467.75 5074.17 2477.63 5097.24 2477.63 5111.52 2458.96 5126.91 2455.66 5148.88 2462.25 5162.06 2458.96 5178.98 2420.5 5191.73 2415.01 5204.91 2425.99 5218.1 2433.69 5233.48 2438.08 5248.52 2420.5 5253.25 2397.43 5297.2 2337 5309.29 2294.15 5334.56 2296.35 5360.93 2288.66 5375.21 2274.38 5382.9 2255.7 5374.11 2237.02 5369.72 2222.74 5380.7 2211.75 5421.35 2211.75 5449.92 2230.43 5485.08 2265.59 5611.43 2265.59 5636.7 2251.3 5660.87 2263.39 5689.43 2286.46 5703.72 2298.55 5725.69 2290.86 5743.27 2262.29 5744.37 2230.43 5756.45 2196.37 5780.63 2168.9 5812.49 2120.56 5827.87 2099.68 5864.13 2086.5 5882.8 2051.34 5897.09 2009.59 5902.58 1934.88 5903.68 1865.66 5914.82 1861.27 5942.13 2022.78 6264.05 1962.35 6460.71 1922.79 6537.62 1904.12 6571.68 1898.62 6580.47 1873.35 6607.94 1861.27'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='southeast'
				className={`polygon ${selectedRegion === 'southeast' ? 'selected' : ''}`}
				onClick={() => handleRegionClick('southeast')}
			/>
			<polygon
				id='midwest'
				points='5914.82 1861.27 5903.68 1865.66 5902.58 1934.88 5897.09 2009.59 5864.13 2086.5 5827.87 2099.68 5812.49 2120.56 5780.63 2168.9 5756.45 2196.37 5744.37 2230.43 5743.27 2262.29 5725.69 2290.86 5703.72 2298.55 5689.43 2286.46 5660.87 2263.39 5636.7 2251.3 5611.43 2265.59 5485.08 2265.59 5449.92 2230.43 5421.35 2211.75 5380.7 2211.75 5369.72 2222.74 5374.11 2237.02 5382.9 2255.7 5375.21 2274.38 5360.93 2288.66 5334.56 2296.35 5309.29 2294.15 5297.2 2337 5253.25 2397.43 5248.52 2420.5 5233.48 2438.08 5218.1 2433.69 5204.91 2425.99 5191.73 2415.01 5178.98 2420.5 5162.06 2458.96 5148.88 2462.25 5126.91 2455.66 5111.52 2458.96 5097.24 2477.63 5074.17 2477.63 5054.39 2467.75 5020.33 2477.63 4966.5 2497.41 4962.1 2511.69 4958.81 2539.16 4951.11 2556.74 4931.34 2565.53 4907.17 2589.7 4913.76 2601.79 4920.35 2612.77 4915.96 2630.35 4891.79 2635.84 4868.71 2617.17 4843.72 2607.83 4823.67 2622.66 4820.37 2647.93 4825.86 2684.19 4819.27 2720.44 4792.9 2728.13 4774.23 2760 4769.83 2794.06 4750.05 2844.6 4696.22 2843.5 4673.15 2847.89 4668.75 2836.9 4678.64 2820.42 4695.12 2803.94 4697.32 2774.28 4680.84 2758.9 4585.25 2763.29 4390.78 2776.48 4151.27 2784.43 4053.49 2784.43 4051.29 2697.37 3414.05 2697.37 3180.03 2689.68 3011.93 2686.38 3045.99 1962.35 2894.37 1954.66 2779 1950.26 2880.08 532.95 3260.23 550.53 3687.62 562.62 3932.63 556.02 3932.63 494.5 3952.41 495.6 3976.58 508.78 3988.66 583.49 4004.04 608.76 4091.94 619.75 4100.73 636.23 4124.9 636.23 4138.08 627.44 4156.76 615.35 4184.23 615.35 4213.89 627.44 4241.36 648.31 4262.24 672.49 4279.82 675.78 4288.6 659.3 4306.18 661.5 4343.54 691.16 4374.3 706.55 4399.57 703.25 4431.43 672.49 4451.21 672.49 4462.2 684.57 4543.5 684.57 4557.78 701.05 4600.63 703.25 4578.66 727.42 4544.6 743.9 4507.24 757.08 4476.48 775.76 4438.03 806.53 4402.87 851.57 4369.91 886.73 4322.66 927.38 4318.27 946.06 4352.33 951.55 4367.71 947.16 4389.68 936.17 4418.25 920.79 4440.22 907.61 4462.2 892.22 4478.68 903.21 4473.18 916.39 4461.1 939.47 4470.99 953.75 4494.06 949.36 4511.64 960.34 4536.91 958.15 4570.97 933.97 4601.73 906.51 4640.19 904.31 4666.55 892.22 4695.12 862.56 4726.98 833.99 4744.56 847.18 4762.14 870.25 4762.14 898.82 4778.62 888.93 4791.8 873.55 4835.75 873.55 4878.6 909.8 4904.97 932.88 4988.47 932.88 5036.81 901.01 5066.48 891.13 5107.13 887.83 5143.39 875.74 5163.16 860.36 5188.43 860.36 5188.43 914.2 5219.2 914.2 5237.87 908.7 5263.14 904.31 5284.02 915.3 5303.79 951.55 5329.06 971.33 5334.56 990.01 5248.86 990.01 5237.87 999.9 5225.79 1015.28 5208.21 1002.09 5189.53 986.71 5143.39 987.81 5125.81 996.6 5102.73 1014.18 5066.48 1017.47 5036.81 1033.95 5022.53 1050.44 5001.65 1047.14 4980.78 1059.22 4965.4 1071.31 4957.71 1051.53 4944.52 1066.92 4931.34 1104.27 4911.56 1148.22 4897.28 1188.87 4884.09 1215.24 4861.02 1247.1 4854.43 1265.78 4857.73 1288.85 4875.31 1282.26 4893.98 1251.5 4917.06 1227.32 4932.44 1247.1 4930.24 1276.77 4918.15 1306.43 4918.15 1358.07 4903.87 1376.75 4903.87 1453.65 4893.98 1478.92 4893.98 1552.54 4904.97 1583.3 4917.06 1666.8 4928.04 1721.73 4952.21 1770.08 4975.29 1803.04 5007.15 1803.04 5035.71 1787.66 5076.37 1753.6 5099.44 1705.25 5113.72 1647.02 5113.72 1564.62 5097.24 1521.77 5077.46 1480.02 5058.79 1440.47 5058.79 1363.56 5066.48 1333.9 5079.66 1297.64 5079.66 1236.11 5098.34 1203.15 5119.21 1175.69 5143.39 1149.32 5174.15 1121.85 5200.52 1110.86 5212.6 1098.78 5202.71 1070.21 5215.9 1046.04 5232.38 1028.46 5262.04 1039.45 5308.19 1060.32 5354.33 1073.51 5401.58 1093.28 5426.85 1117.46 5413.66 1130.64 5411.47 1148.22 5431.24 1172.39 5445.53 1198.76 5445.53 1261.38 5424.65 1277.86 5410.37 1318.52 5386.2 1336.09 5380.7 1364.66 5400.48 1391.03 5424.65 1388.83 5452.12 1356.97 5470.8 1319.61 5503.76 1302.04 5531.77 1312.79 5559.79 1351.48 5585.06 1420.69 5599.34 1478.92 5599.34 1541.55 5589.45 1560.23 5581.76 1553.64 5567.48 1550.34 5554.3 1585.5 5536.72 1619.56 5522.43 1653.62 5501.56 1697.56 5499.36 1727.23 5540.01 1734.92 5568.58 1745.91 5610.33 1761.29 5636.7 1765.68 5674.05 1741.51 5716.9 1736.02 5753.16 1706.35 5788.32 1672.29 5825.67 1647.02 5873.45 1616.62 5914.82 1861.27'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='midwest'
				className={`polygon ${selectedRegion === 'midwest' ? 'selected' : ''}`}
				onClick={() => handleRegionClick('midwest')}
			/>
			<polygon
				id='southwest'
				points='4188.62 3996.02 4140.51 4010.31 4080.95 4033.38 4064.47 4035.58 4053.49 4018 4041.4 4010.31 4029.31 4023.87 4029.31 4076.23 4005.14 4103.69 3972.18 4133.36 3926.04 4165.22 3864.51 4202.58 3852.42 4192.69 3829.35 4190.49 3806.28 4198.89 3806.28 4226.75 3764.32 4253.36 3729.37 4282.78 3686.52 4334.42 3666.75 4341.01 3659.06 4365.79 3654.66 4404.74 3627.19 4488.07 3627.19 4513.51 3648.07 4579.43 3659.06 4638.75 3659.06 4686 3628.29 4668.42 3595.33 4651.94 3563.47 4650.84 3538.2 4638.76 3485.46 4617.88 3422.84 4610.19 3387.68 4577.23 3345.93 4493.73 3322.86 4456.37 3321.76 4384.96 3269.02 4335.52 3258.03 4308.05 3238.26 4265.2 3200.9 4215.76 3174.53 4171.81 3149.26 4115.78 3113.01 4065.24 3082.24 4020.19 3033.9 3989.43 2982.26 3964.16 2914.14 3957.57 2872.39 3970.75 2826.25 4010.31 2785.6 4060.85 2765.82 4100.4 2741.65 4102.6 2659.25 4044.37 2563.66 3969.65 2544.98 3932.3 2524.11 3877.36 2485.65 3785.07 2431.82 3722.45 2381.28 3662.02 2308.77 3580.72 2272.51 3556.55 2035.19 3534.57 2025.3 3611.48 1897.86 3601.59 1596.81 3560.94 1078.23 3264.3 1072.74 3248.91 1087.02 3233.53 1081.53 3223.64 1121.08 3220.35 1141.96 3200.57 1129.87 3181.89 1111.19 3168.71 1112.29 3123.66 1129.87 3094 1158.44 3055.54 1165.03 3034.67 1170.52 3010.5 1192.5 2985.23 1222.16 2963.25 1222.16 2944.58 1200.19 2914.91 1194.69 2876.46 1184.81 2853.39 1181.51 2812.73 1197.99 2773.18 1197.99 2646.83 1216.67 2623.76 1240.28 2623.76 1254.02 2636.94 1269.4 2650.13 1285.89 2650.13 1302.37 2628.15 1315.55 2585.3 1322.14 2528.17 1328.73 2485.32 1528.7 2520.48 1902.25 2578.71 2028.6 2596.29 2331.84 2630.35 2643.87 2660.02 2872.39 2675.4 3011.93 2686.38 3180.03 2689.68 3414.05 2697.37 4051.29 2697.37 4053.49 2784.43 4053.49 2807.24 4075.46 2898.43 4085.35 2987.43 4085.35 3295.06 4093.04 3304.95 4111.72 3309.34 4149.07 3310.44 4155.66 3404.93 4155.66 3585.11 4178.74 3609.28 4202.91 3659.82 4228.18 3720.25 4238.07 3760.9 4232.57 3790.57 4216.09 3831.22 4218.29 3924.61 4204.01 3953.17 4188.62 3996.02'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='southwest'
				className={`polygon ${selectedRegion === 'southwest' ? 'selected' : ''}`}
				onClick={() => handleRegionClick('southwest')}
			/>
			<polygon
				id='rocky-mountains'
				points='1181.51 2812.73 1197.99 2773.18 1197.99 2646.83 1216.67 2623.76 1240.28 2623.76 1254.02 2636.94 1269.4 2650.13 1285.89 2650.13 1302.37 2628.15 1315.55 2585.3 1322.14 2528.17 1328.73 2485.32 1528.7 2520.48 1902.25 2578.71 2028.6 2596.29 2331.84 2630.35 2643.87 2660.02 2872.39 2675.4 3011.93 2686.38 3045.99 1962.35 2779 1950.26 2880.08 532.95 2409.85 487.91 1989.05 434.07 1702.29 384.63 1469.37 339.58 1352.91 317.61 1281.49 672.49 1263.91 769.17 1263.91 842.78 1290.28 884.53 1301.27 907.61 1294.67 930.68 1260.62 977.92 1230.95 1026.26 1205.68 1052.63 1167.23 1094.38 1167.23 1127.85 1184.81 1140.53 1193.6 1150.42 1185.9 1184.48 1167.23 1228.69 1104.6 1530.56 718.96 1444.86 597.01 1964.55 1181.51 2812.73'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='rocky-mountains'
				className={`polygon ${selectedRegion === 'rocky-mountains' ? 'selected' : ''}`}
				onClick={() => handleRegionClick('rocky-mountains')}
			/>
			<polygon
				id='pacific'
				points='1081.53 3223.64 1121.08 3220.35 1141.96 3200.57 1129.87 3181.89 1111.19 3168.71 1112.29 3123.66 1129.87 3094 1158.44 3055.54 1165.03 3034.67 1170.52 3010.5 1192.5 2985.23 1222.16 2963.25 1222.16 2944.58 1200.19 2914.91 1194.69 2876.46 1184.81 2853.39 1181.51 2812.73 597.01 1964.55 718.96 1444.86 1104.6 1530.56 1167.23 1228.69 1185.9 1184.48 1193.6 1150.42 1167.23 1127.85 1167.23 1094.38 1230.95 1026.26 1260.62 977.92 1294.67 930.68 1301.27 907.61 1290.28 884.53 1263.91 842.78 1263.91 769.17 1352.91 317.61 934.3 219.83 702.48 155 694.79 172.58 701.38 197.85 711.27 213.23 713.47 225.32 707.97 238.5 705.78 248.39 705.78 347.27 675.01 387.93 675.01 441.47 659.63 441.47 658.53 418.69 651.94 395.62 654.14 373.64 673.91 360.46 673.91 345.08 661.83 324.2 658.53 303.33 642.05 315.41 621.18 298.93 609.09 280.25 553.06 263.77 521.2 256.08 444.29 194.56 439.89 247.29 444.29 292.34 444.29 441.76 478.35 462.64 455.28 469.23 445.39 473.62 445.39 490.1 453.08 509.88 453.08 541.74 434.4 548.33 425.61 543.94 416.82 563.72 436.6 582.39 436.6 598.87 412.43 637.33 391.55 701.05 371.78 777.96 345.41 844.98 320.14 903.21 280.58 992.2 268.5 1028.46 234.44 1066.92 194.89 1135.03 194.89 1195.15 177.31 1236.11 177.31 1275.99 194.89 1305.33 177.31 1351.62 154.23 1450.36 127.87 1514.08 100.4 1570.12 103.69 1605.27 127.87 1685.48 122.37 1739.31 105.89 1816.22 109.19 1877.75 125.67 1918.4 154.23 1964.55 166.32 1987.62 168.52 2044.75 210.27 2081.01 221.25 2046.95 248.72 2032.66 294.87 2032.66 324.53 2049.14 347.6 2066.72 352 2087.6 324.53 2077.71 299.26 2060.13 255.31 2051.34 235.54 2061.23 237.74 2098.59 246.52 2121.66 257.51 2159.01 228.95 2137.04 215.76 2099.68 198.18 2124.95 202.58 2180.99 228.95 2257.9 246.52 2300.74 238.83 2342.49 227.85 2367.76 228.95 2399.63 257.51 2460.05 303.66 2545.75 339.91 2614.97 336.62 2646.83 324.53 2680.89 347.6 2714.95 375.07 2747.91 473.95 2811.64 560.75 2861.08 597.01 2886.35 609.09 2913.81 611.29 2942.38 647.55 2962.16 684.9 2995.12 714.57 3035.77 729.95 3074.22 731.05 3131.35 727.75 3162.12 745.33 3190.68 1081.53 3223.64'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='pacific'
				className={`polygon ${selectedRegion === 'pacific' ? 'selected' : ''}`}
				onClick={() => handleRegionClick('pacific')}
			/>
			<rect x='3375' y='3810' width='178.58' height='48.69' fill='none' className='shape' />
			<path
				d='M3385.07,3842.85l-6.43,12.79h-5.24l20.89-40.44h5.88l5.59,40.44h-5.1l-1.63-12.79h-13.96ZM3398.66,3838.89l-1.57-11.68c-.22-2.11-.52-5.07-.72-7.44h-.14c-1.08,2.41-2.08,4.93-3.31,7.37l-6.03,11.76h11.77Z'
				className='shape'
			/>
			<path
				d='M3443.64,3826.63l-3.91,20.57c-.61,3.23-1.02,6.04-1.3,8.44h-4.49l.75-5.48h-.12c-2.59,3.78-6.4,6.14-10.24,6.14s-7.66-1.8-7.66-8.4c0-1.4.18-2.96.56-4.88l3.14-16.39h4.97l-3.08,16.17c-.31,1.61-.49,3.01-.49,4.25,0,3,1.23,5.05,4.64,5.05,3.63,0,8.25-4.23,9.45-10.6l2.83-14.88h4.96Z'
				className='shape'
			/>
			<path
				d='M3451.94,3850.6c1.37.82,3.85,1.81,6.24,1.81,3.35,0,5.52-2.16,5.52-4.74,0-2.27-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.71,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.43,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M3491.87,3818.83l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.73.82,2.81,2.75,2.81.89,0,1.69-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.44l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
			<path
				d='M3502.46,3855.64l5.54-29.02h4.97l-5.54,29.02h-4.96ZM3508.92,3818.53c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.45,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M3521,3855.64l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.96l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.1h-4.96Z'
				className='shape'
			/>
			<polygon
				points='3585.71 3855.48 3586.12 3871.87 3603.36 3871.87 3586.37 3882 3586.78 3898.4 3575.87 3888.27 3558.88 3898.4 3569.13 3882 3558.23 3871.87 3575.47 3871.87 3585.71 3855.48'
				className='shape'
			/>
			<rect
				x='4616.11'
				y='3757.61'
				width='360.89'
				height='50.54'
				fill='none'
				className='shape'
			/>
			<path
				d='M4625.55,3764.31c2.47-.5,5.39-.84,8.67-.84,4.17,0,7.18.84,9.33,2.77,1.86,1.52,2.9,3.67,2.9,6.3,0,5.11-4.12,8.9-8.71,10.09v.16c3.65,1.06,6.67,4.11,6.63,8.98,0,4.14-2.19,7.39-4.84,9.36-3.21,2.41-7.67,3.32-13.09,3.32-3.47,0-6.49-.21-8.38-.57l7.48-39.57ZM4623.64,3800.15c1.26.2,2.73.26,4.09.26,5.89.03,11.42-2.43,11.42-8.9,0-4.75-4.01-6.83-8.54-6.83h-4.05l-2.92,15.47ZM4627.34,3780.9h3.7c5.8,0,10.27-3.01,10.27-7.92,0-3.9-2.94-5.56-7.34-5.56-1.83,0-3.36.13-4.13.37l-2.5,13.11Z'
				className='shape'
			/>
			<path
				d='M4673.12,3804.18c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM4676.34,3778.87c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M4703.04,3767.36l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.73.82,2.81,2.75,2.81.89,0,1.69-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.44l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
			<path
				d='M4741.24,3786.57c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM4718.92,3792.73c0,4.71,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M4749.51,3804.18l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.1h-4.97Z'
				className='shape'
			/>
			<path
				d='M4809.84,3764.33c2.47-.56,5.81-.86,8.82-.86,4.04,0,7.5.95,9.66,2.93,1.87,1.62,2.99,3.94,2.99,6.69,0,5.87-4.5,10.26-9.6,11.69v.15c2.81.94,4.15,3.97,4.45,8.12.45,5.64.73,9.5,1.26,11.13h-5.15c-.23-.86-.65-5.09-.94-9.75-.32-5.57-2.36-7.86-6.38-7.86h-4.42l-3.34,17.62h-4.93l7.58-39.84ZM4811.29,3782.69h4.46c6.31,0,10.37-4.11,10.37-8.97,0-4.33-3.26-6.27-7.81-6.27-1.98,0-3.26.17-4.19.43l-2.82,14.81Z'
				className='shape'
			/>
			<path
				d='M4865.98,3786.57c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM4843.66,3792.73c0,4.71,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M4902.55,3775.16l-3.91,20.57c-.61,3.23-1.02,6.04-1.3,8.44h-4.49l.75-5.48h-.12c-2.59,3.78-6.4,6.14-10.24,6.14s-7.66-1.8-7.66-8.4c0-1.4.18-2.96.56-4.88l3.14-16.39h4.96l-3.08,16.17c-.31,1.61-.49,3.01-.49,4.25,0,3,1.23,5.05,4.64,5.05,3.63,0,8.25-4.23,9.45-10.6l2.83-14.88h4.96Z'
				className='shape'
			/>
			<path
				d='M4910.62,3810.77c1.76,1.12,4.65,1.9,7.7,1.9,4.88,0,8.71-2.48,10.43-10.33l.96-4.34h-.15c-2.54,4.15-6.08,6.17-10.09,6.17-5.83,0-8.83-4.91-8.84-10.05-.02-9.88,7.19-19.61,18.42-19.61,3.37,0,7.03.94,9.31,2.02l-4.45,23.98c-1.17,6.15-2.83,10.39-5.85,12.99-2.9,2.51-6.82,3.22-10.13,3.22-3.53,0-6.88-.82-8.7-2.05l1.39-3.9ZM4932.93,3779.48c-.92-.46-2.72-.99-4.8-.99-7.26,0-12.26,7.59-12.29,14.76-.02,3.22,1.14,6.96,5.56,6.96s8.61-5.39,9.68-11.06l1.85-9.67Z'
				className='shape'
			/>
			<path
				d='M4967.54,3802.51c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM4962.03,3778.37c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<polygon
				points='4597.71 3803.84 4598.11 3820.23 4615.35 3820.23 4598.36 3830.37 4598.77 3846.76 4587.86 3836.63 4570.88 3846.76 4581.12 3830.37 4570.22 3820.23 4587.46 3820.23 4597.71 3803.84'
				className='shape'
			/>
			<rect x='4500' y='3500' width='223.46' height='46.66' fill='none' className='shape' />
			<path
				d='M4499.22,3539.99c1.32.56,2.95.88,5.09.88,4.24,0,6.94-2.24,8.28-9.4l5.18-27.28h4.96l-5.28,27.83c-1.78,9.47-5.73,13.27-13.31,13.27-2.44,0-4.98-.52-6-1.05l1.08-4.25Z'
				className='shape'
			/>
			<path
				d='M4547.7,3544.63c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM4550.93,3519.33c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M4584.54,3543.48c-1.48.73-4.49,1.78-8.43,1.78-7.46,0-11.16-5.06-11.16-11.22,0-9.9,7.37-19.07,17.8-19.07,2.7,0,5.15.79,6.03,1.32l-1.42,3.95c-1.15-.55-2.74-1.09-4.93-1.09-7.53,0-12.3,7.43-12.3,14.27,0,4.72,2.47,7.76,7.23,7.76,2.95,0,5.22-.91,6.7-1.62l.48,3.93Z'
				className='shape'
			/>
			<path
				d='M4594.77,3544.63l8.1-42.6h4.95l-5.1,26.71h.12c.88-1.02,1.95-2.12,2.71-2.92l10.23-10.2h6.15l-12.66,11.91,8.66,17.1h-5.48l-6.99-14.32-3.67,3.28-2.08,11.05h-4.94Z'
				className='shape'
			/>
			<path
				d='M4627.16,3539.59c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.27-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.71,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.43,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M4681.94,3527.02c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM4659.63,3533.18c0,4.71,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M4690.22,3544.63l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.1h-4.97Z'
				className='shape'
			/>
			<polygon
				points='4759.18 3480.82 4759.58 3497.22 4776.82 3497.22 4759.84 3507.35 4760.24 3523.75 4749.34 3513.61 4732.35 3523.75 4742.6 3507.35 4731.69 3497.22 4748.93 3497.22 4759.18 3480.82'
				className='shape'
			/>
			<rect
				x='5318.14'
				y='3444.48'
				width='361.86'
				height='48.52'
				fill='none'
				className='shape'
			/>
			<path
				d='M5353.88,3490.04l2.9-21.84c.53-3.86,1.42-9.78,2.19-13.68h-.19c-1.87,4.08-4.12,8.89-6.33,13.03l-12.01,22.24h-3.8l-2.99-21.78c-.62-4.64-1.03-9.34-1.3-13.48h-.13c-.85,3.74-2.12,9.84-3.08,13.69l-5.5,21.83h-4.68l10.47-40.44h6.35l3.2,23.19c.4,3.44.87,7.13.97,10.14h.18c1.23-3.01,2.96-6.63,4.71-10l12.52-23.33h6.51l-5.13,40.44h-4.84Z'
				className='shape'
			/>
			<path
				d='M5399.29,3472.43c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM5376.97,3478.59c0,4.71,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M5407.56,3490.04l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.1h-4.97Z'
				className='shape'
			/>
			<path
				d='M5457.39,3453.23l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.73.82,2.81,2.75,2.81.89,0,1.69-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.44l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
			<path
				d='M5467.94,3496.63c1.76,1.12,4.65,1.9,7.7,1.9,4.88,0,8.71-2.48,10.43-10.33l.96-4.34h-.15c-2.54,4.15-6.08,6.17-10.09,6.17-5.83,0-8.83-4.91-8.84-10.05-.02-9.88,7.19-19.61,18.42-19.61,3.37,0,7.03.94,9.31,2.02l-4.45,23.98c-1.17,6.15-2.83,10.39-5.85,12.99-2.9,2.51-6.82,3.22-10.13,3.22-3.53,0-6.88-.82-8.7-2.05l1.39-3.9ZM5490.24,3465.34c-.92-.46-2.72-.99-4.8-.99-7.26,0-12.26,7.59-12.29,14.76-.02,3.22,1.14,6.96,5.56,6.96s8.61-5.39,9.68-11.06l1.85-9.67Z'
				className='shape'
			/>
			<path
				d='M5531.77,3472.43c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM5509.45,3478.59c0,4.71,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M5540.04,3490.04l3.85-20.57c.63-3.23,1.03-6.04,1.34-8.45h4.39l-.77,5.44h.14c2.72-4.05,6.37-6.1,10.22-6.1,4.42,0,6.57,2.8,6.78,6.47,2.6-4.2,6.29-6.41,10.66-6.47,3.36,0,7.05,2.14,7.05,7.61,0,1.34-.18,3.29-.48,4.93l-3.24,17.13h-4.86l3.13-16.71c.21-1.12.42-2.59.42-3.79,0-3.07-1.16-5.04-4.37-5.04-3.63,0-7.92,4.18-9.12,10.67l-2.77,14.87h-4.84l3.24-17.03c.24-1.3.39-2.41.39-3.54,0-2.44-.68-4.97-4.35-4.97s-8.15,4.8-9.27,10.96l-2.68,14.59h-4.86Z'
				className='shape'
			/>
			<path
				d='M5614.25,3488.38c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM5608.74,3464.24c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M5625.3,3490.04l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.98,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.97Z'
				className='shape'
			/>
			<path
				d='M5656.71,3461.02l2.87,15.61c.64,3.34,1.02,5.48,1.31,7.65h.15c.76-1.86,1.62-3.9,3.08-7.11l7.43-16.15h5.28l-10.9,22.05c-3.11,6.29-6.05,11.38-10,15.27-3.24,3.27-6.79,4.65-8.44,5.01l-1.22-4.28c1.25-.44,3.35-1.25,5.32-2.79,1.96-1.51,4.06-3.85,5.61-6.7.25-.48.23-.81.15-1.32l-5.82-27.25h5.17Z'
				className='shape'
			/>
			<polygon
				points='5310.72 3410.51 5311.13 3426.9 5328.37 3426.9 5311.38 3437.03 5311.78 3453.43 5300.88 3443.3 5283.89 3453.43 5294.14 3437.03 5283.23 3426.9 5300.47 3426.9 5310.72 3410.51'
				className='shape'
			/>
			<rect x='5684' y='3744.42' width='331' height='49.58' fill='none' className='shape' />
			<path
				d='M5699.73,3754.4h-11.81l.85-4.33h28.64l-.84,4.33h-11.88l-6.84,36.11h-4.96l6.84-36.11Z'
				className='shape'
			/>
			<path
				d='M5733.63,3790.51c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM5736.85,3765.21c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path d='M5750.52,3790.51l8.12-42.6h4.98l-8.13,42.6h-4.96Z' className='shape' />
			<path d='M5769.06,3790.51l8.12-42.6h4.98l-8.13,42.6h-4.96Z' className='shape' />
			<path
				d='M5806.82,3790.51c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM5810.05,3765.21c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M5823.7,3790.51l8.1-42.6h4.98l-3.62,18.7h.12c2.49-3.53,5.99-5.77,10.37-5.77,3.29,0,7.22,1.99,7.22,7.77,0,1.55-.19,3.44-.48,4.91l-3.23,16.99h-4.97l3.18-16.77c.2-1.06.39-2.4.39-4,0-2.67-1.28-4.76-4.51-4.76-3.85,0-8.67,4.5-9.88,11l-2.71,14.54h-4.97Z'
				className='shape'
			/>
			<path
				d='M5879.78,3790.51c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM5883.01,3765.21c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M5897.03,3785.47c1.37.82,3.85,1.81,6.24,1.81,3.35,0,5.52-2.16,5.52-4.74,0-2.27-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.71,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.43,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M5924.2,3785.47c1.37.82,3.85,1.81,6.24,1.81,3.35,0,5.52-2.16,5.52-4.74,0-2.27-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.71,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.43,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M5972.07,3788.85c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM5966.57,3764.71c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M6004.11,3788.85c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM5998.6,3764.71c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<polygon
				points='5663.4 3708.25 5663.81 3724.65 5681.05 3724.65 5664.06 3734.78 5664.46 3751.18 5653.56 3741.04 5636.57 3751.18 5646.82 3734.78 5635.91 3724.65 5653.15 3724.65 5663.4 3708.25'
				className='shape'
			/>
			<rect
				x='5585.26'
				y='3173.1'
				width='210.74'
				height='49.9'
				fill='none'
				className='shape'
			/>
			<path
				d='M5595.33,3206.56l-6.43,12.79h-5.24l20.89-40.44h5.88l5.59,40.44h-5.1l-1.63-12.79h-13.96ZM5608.91,3202.6l-1.57-11.68c-.22-2.11-.52-5.07-.72-7.44h-.14c-1.08,2.41-2.08,4.93-3.31,7.37l-6.03,11.76h11.77Z'
				className='shape'
			/>
			<path
				d='M5638.58,3182.54l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.73.82,2.81,2.75,2.81.89,0,1.69-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.44l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
			<path d='M5649.19,3219.35l8.12-42.6h4.98l-8.13,42.6h-4.96Z' className='shape' />
			<path
				d='M5686.96,3219.35c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM5690.18,3194.05c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M5703.95,3219.35l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.97Z'
				className='shape'
			/>
			<path
				d='M5753.78,3182.54l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.73.82,2.81,2.75,2.81.89,0,1.69-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.44l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
			<path
				d='M5783.55,3219.35c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM5786.78,3194.05c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<polygon
				points='5576.74 3136.93 5577.14 3153.33 5594.38 3153.33 5577.39 3163.46 5577.8 3179.86 5566.89 3169.72 5549.91 3179.86 5560.15 3163.46 5549.25 3153.33 5566.49 3153.33 5576.74 3136.93'
				className='shape'
			/>
			<rect x='5776' y='2975' width='269.41' height='44.29' fill='none' className='shape' />
			<path
				d='M5805.82,3017.14c-2.28,1.02-5.95,1.94-10.49,1.94-10.18,0-16.41-6.47-16.41-16.79,0-7.61,3.08-14.87,8.63-19.49,4.18-3.53,9.33-5.42,15.24-5.42,4.5,0,7.73,1.12,8.76,1.94l-1.6,4.01c-1.5-.91-4.35-1.66-7.95-1.66-4.23,0-8.47,1.64-11.58,4.53-3.8,3.56-6.2,9.26-6.2,15.39,0,7.23,3.32,13.2,12.3,13.2,3.05,0,6.39-.61,8.64-1.73l.66,4.07Z'
				className='shape'
			/>
			<path
				d='M5843.23,3000.83c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM5820.91,3006.99c0,4.72,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path d='M5851.52,3018.44l8.12-42.6h4.98l-8.13,42.6h-4.96Z' className='shape' />
			<path
				d='M5898.34,2989.43l-3.91,20.57c-.61,3.23-1.02,6.04-1.3,8.45h-4.49l.75-5.48h-.12c-2.59,3.78-6.4,6.14-10.24,6.14s-7.66-1.8-7.66-8.4c0-1.4.18-2.96.56-4.88l3.14-16.39h4.96l-3.08,16.17c-.31,1.61-.49,3.01-.49,4.25,0,3,1.23,5.05,4.64,5.05,3.63,0,8.25-4.23,9.45-10.6l2.83-14.88h4.96Z'
				className='shape'
			/>
			<path
				d='M5906.4,3018.44l3.85-20.57c.63-3.23,1.03-6.04,1.34-8.45h4.39l-.77,5.44h.14c2.72-4.05,6.37-6.1,10.22-6.1,4.42,0,6.57,2.8,6.78,6.47,2.6-4.2,6.29-6.41,10.66-6.47,3.36,0,7.05,2.14,7.05,7.61,0,1.34-.18,3.29-.48,4.93l-3.24,17.13h-4.86l3.13-16.71c.21-1.12.42-2.59.42-3.79,0-3.07-1.16-5.04-4.37-5.04-3.63,0-7.92,4.18-9.12,10.67l-2.77,14.87h-4.84l3.24-17.03c.24-1.3.39-2.41.39-3.54,0-2.44-.68-4.97-4.35-4.97s-8.15,4.8-9.27,10.96l-2.68,14.59h-4.86Z'
				className='shape'
			/>
			<path
				d='M5972.47,2975.85l-3.83,18.83.12.03c2.58-3.91,6.3-5.94,10.21-5.94,6.36,0,8.79,5.25,8.79,10.39,0,8.93-6.45,19.94-18.08,19.94-5.11,0-8.95-2.13-8.94-7.49,0-1.42.24-3.12.51-4.51l6.25-31.26h4.98ZM5966.18,3007.23c-.2.99-.38,2.14-.36,3.68.03,2.76,1.61,4.28,4.7,4.28,7.52,0,12.06-8.92,12.06-15.37,0-3.6-1.57-6.91-5.54-6.91-4.29,0-8.75,4.45-10.21,11.24l-.65,3.09Z'
				className='shape'
			/>
			<path
				d='M5995.98,3018.44l5.54-29.02h4.96l-5.54,29.02h-4.97ZM6002.44,2981.33c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.45,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M6033.76,3018.44c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM6036.99,2993.14c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<polygon
				points='6051.37 3023.77 6051.78 3040.16 6069.02 3040.16 6052.03 3050.3 6052.43 3066.69 6041.53 3056.56 6024.54 3066.69 6034.79 3050.3 6023.88 3040.16 6041.12 3040.16 6051.37 3023.77'
				className='shape'
			/>
			<rect
				x='5183.13'
				y='2718.25'
				width='258.87'
				height='48.34'
				fill='none'
				className='shape'
			/>
			<path
				d='M5185,2763.72l7.69-40.44h5.45l9.26,22.9c1.79,4.6,2.7,7.8,3.55,11.28l.13-.06c.22-3.63.64-6.99,1.69-12.66l4.08-21.45h4.71l-7.69,40.44h-4.92l-9.22-22.86c-1.97-5-2.87-7.84-3.75-11.67l-.18.06c-.45,3.78-1.09,7.82-2.12,13.32l-3.99,21.14h-4.69Z'
				className='shape'
			/>
			<path
				d='M5246.8,2763.72c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM5250.02,2738.41c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M5264.04,2758.68c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.26-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.7,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.43,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M5290.98,2763.72l8.1-42.6h4.98l-3.62,18.7h.12c2.49-3.53,5.99-5.77,10.37-5.77,3.29,0,7.22,1.99,7.22,7.77,0,1.55-.19,3.44-.48,4.91l-3.23,16.99h-4.97l3.18-16.77c.2-1.06.39-2.4.39-4,0-2.67-1.28-4.76-4.51-4.76-3.85,0-8.67,4.5-9.88,11l-2.71,14.54h-4.97Z'
				className='shape'
			/>
			<path
				d='M5333.91,2734.7l2.5,16.52c.44,3.3.81,5.54.93,7.13h.17c.64-1.54,1.41-3.45,3.09-6.76l8.86-16.89h5.45l-16.15,29.02h-4.9l-5.01-29.02h5.07Z'
				className='shape'
			/>
			<path
				d='M5359.55,2763.72l5.54-29.02h4.96l-5.54,29.02h-4.97ZM5366.02,2726.6c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.45,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path d='M5378.11,2763.72l8.12-42.6h4.98l-8.13,42.6h-4.96Z' className='shape' />
			<path d='M5396.65,2763.72l8.12-42.6h4.98l-8.13,42.6h-4.96Z' className='shape' />
			<path
				d='M5436.1,2762.05c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM5430.6,2737.91c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<polygon
				points='5169.12 2754.59 5169.53 2770.98 5186.77 2770.98 5169.78 2781.12 5170.19 2797.51 5159.28 2787.38 5142.29 2797.51 5152.54 2781.12 5141.63 2770.98 5158.87 2770.98 5169.12 2754.59'
				className='shape'
			/>
			<rect
				x='4400.67'
				y='3077.52'
				width='297.33'
				height='49.44'
				fill='none'
				className='shape'
			/>
			<path
				d='M4410.23,3083.1h4.98l-6.89,36.11h16.31l-.83,4.33h-21.25l7.69-40.44Z'
				className='shape'
			/>
			<path
				d='M4433.69,3123.54l5.54-29.02h4.96l-5.54,29.02h-4.97ZM4440.15,3086.42c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.45,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M4465.22,3086.73l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.73.82,2.81,2.75,2.81.89,0,1.69-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.44l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
			<path
				d='M4488.8,3086.73l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.73.82,2.81,2.75,2.81.89,0,1.69-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.44l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
			<path d='M4499.4,3123.54l8.12-42.6h4.98l-8.13,42.6h-4.96Z' className='shape' />
			<path
				d='M4538.86,3121.87c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM4533.35,3097.73c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M4573.39,3083.69c2.47-.56,5.81-.86,8.82-.86,4.04,0,7.5.95,9.66,2.93,1.87,1.62,2.99,3.94,2.99,6.69,0,5.87-4.5,10.26-9.6,11.69v.15c2.81.94,4.15,3.97,4.45,8.12.45,5.64.73,9.5,1.26,11.13h-5.15c-.23-.86-.65-5.09-.94-9.75-.32-5.57-2.36-7.86-6.38-7.86h-4.42l-3.34,17.62h-4.93l7.58-39.84ZM4574.84,3102.06h4.46c6.31,0,10.37-4.12,10.37-8.97,0-4.33-3.26-6.27-7.81-6.27-1.98,0-3.26.17-4.19.43l-2.82,14.81Z'
				className='shape'
			/>
			<path
				d='M4629.53,3105.93c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM4607.22,3112.09c0,4.72,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M4657.95,3122.39c-1.48.73-4.49,1.78-8.43,1.78-7.46,0-11.16-5.06-11.16-11.22,0-9.9,7.37-19.07,17.8-19.07,2.7,0,5.15.79,6.03,1.32l-1.42,3.95c-1.15-.55-2.74-1.09-4.93-1.09-7.53,0-12.3,7.43-12.3,14.27,0,4.72,2.47,7.76,7.23,7.76,2.95,0,5.22-.91,6.7-1.62l.48,3.93Z'
				className='shape'
			/>
			<path
				d='M4668.18,3123.54l8.1-42.6h4.95l-5.1,26.71h.12c.88-1.02,1.95-2.12,2.71-2.92l10.23-10.2h6.15l-12.66,11.91,8.66,17.1h-5.48l-6.99-14.32-3.67,3.28-2.08,11.05h-4.94Z'
				className='shape'
			/>
			<polygon
				points='4395.64 3053.43 4396.05 3069.83 4413.29 3069.83 4396.3 3079.96 4396.71 3096.36 4385.8 3086.22 4368.81 3096.36 4379.06 3079.96 4368.16 3069.83 4385.4 3069.83 4395.64 3053.43'
				className='shape'
			/>
			<rect
				x='3643.82'
				y='2977.54'
				width='421.18'
				height='53.84'
				fill='none'
				className='shape'
			/>
			<path
				d='M3683.27,3001.24c0,7.01-2.57,14.74-7.37,19.53-3.58,3.54-8.28,5.64-13.86,5.64-10.45,0-15.33-7.87-15.33-16.46,0-7.11,2.79-15,7.71-19.82,3.47-3.38,8.46-5.48,13.56-5.48,10.88,0,15.29,7.92,15.29,16.58ZM3658.08,2992.91c-3.89,3.9-6.14,11.01-6.14,16.66,0,6.57,2.92,12.64,10.83,12.64,3.45,0,6.72-1.49,9.24-4.04,3.82-3.83,6.02-11.09,6.02-16.72s-1.88-12.59-10.71-12.59c-3.59,0-6.76,1.57-9.24,4.05Z'
				className='shape'
			/>
			<path
				d='M3690.77,3025.75l8.1-42.6h4.95l-5.1,26.71h.12c.88-1.02,1.95-2.12,2.71-2.92l10.23-10.2h6.15l-12.66,11.91,8.66,17.1h-5.48l-6.99-14.32-3.67,3.28-2.08,11.05h-4.94Z'
				className='shape'
			/>
			<path d='M3723.36,3025.75l8.12-42.6h4.98l-8.13,42.6h-4.97Z' className='shape' />
			<path
				d='M3761.12,3025.75c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM3764.35,3000.45c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M3778,3025.75l8.1-42.6h4.98l-3.62,18.7h.12c2.49-3.53,5.99-5.77,10.37-5.77,3.29,0,7.22,1.99,7.22,7.77,0,1.55-.19,3.44-.48,4.91l-3.23,16.99h-4.96l3.18-16.77c.2-1.06.39-2.4.39-4,0-2.67-1.28-4.76-4.51-4.76-3.85,0-8.67,4.5-9.88,11l-2.71,14.54h-4.96Z'
				className='shape'
			/>
			<path
				d='M3842.69,3008.15c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM3820.37,3014.3c0,4.72,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M3850.96,3025.75l3.85-20.57c.63-3.23,1.03-6.04,1.34-8.45h4.39l-.77,5.44h.14c2.72-4.05,6.37-6.1,10.22-6.1,4.42,0,6.57,2.8,6.78,6.47,2.6-4.2,6.29-6.41,10.66-6.47,3.36,0,7.05,2.14,7.05,7.61,0,1.34-.18,3.29-.48,4.93l-3.24,17.13h-4.86l3.13-16.71c.21-1.12.42-2.59.42-3.79,0-3.07-1.16-5.04-4.37-5.04-3.63,0-7.92,4.18-9.12,10.67l-2.77,14.87h-4.84l3.24-17.03c.24-1.3.39-2.41.39-3.54,0-2.44-.68-4.97-4.35-4.97s-8.15,4.8-9.27,10.96l-2.68,14.59h-4.86Z'
				className='shape'
			/>
			<path
				d='M3923.48,3025.75c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM3926.71,3000.45c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M3984.2,3024.45c-2.28,1.02-5.95,1.94-10.49,1.94-10.18,0-16.41-6.47-16.41-16.79,0-7.61,3.08-14.87,8.63-19.49,4.18-3.53,9.33-5.42,15.24-5.42,4.5,0,7.73,1.12,8.76,1.94l-1.6,4.01c-1.5-.91-4.35-1.66-7.95-1.66-4.23,0-8.47,1.64-11.58,4.53-3.8,3.56-6.2,9.26-6.2,15.39,0,7.23,3.32,13.2,12.3,13.2,3.05,0,6.39-.61,8.64-1.73l.66,4.07Z'
				className='shape'
			/>
			<path
				d='M3994.12,3025.75l5.54-29.02h4.96l-5.54,29.02h-4.97ZM4000.58,2988.64c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.45,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M4025.65,2988.94l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.73.82,2.81,2.75,2.81.89,0,1.69-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.44l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
			<path
				d='M4043.23,2996.74l2.87,15.61c.64,3.34,1.02,5.48,1.31,7.65h.15c.76-1.86,1.62-3.89,3.08-7.11l7.43-16.15h5.28l-10.9,22.05c-3.11,6.29-6.05,11.38-10,15.27-3.24,3.27-6.79,4.65-8.44,5.01l-1.22-4.28c1.25-.44,3.35-1.25,5.32-2.79,1.96-1.51,4.06-3.85,5.61-6.7.25-.48.23-.81.15-1.32l-5.82-27.25h5.17Z'
				className='shape'
			/>
			<polygon
				points='3634.2 2943.56 3634.61 2959.96 3651.85 2959.96 3634.86 2970.09 3635.27 2986.49 3624.36 2976.35 3607.37 2986.49 3617.62 2970.09 3606.72 2959.96 3623.96 2959.96 3634.2 2943.56'
				className='shape'
			/>
			<rect
				x='3659'
				y='2302.94'
				width='199.07'
				height='45.05'
				fill='none'
				className='shape'
			/>
			<path
				d='M3674.72,2310.65h-11.81l.85-4.32h28.64l-.84,4.32h-11.87l-6.84,36.11h-4.97l6.84-36.11Z'
				className='shape'
			/>
			<path
				d='M3718.25,2329.16c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM3695.93,2335.31c0,4.72,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.57-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M3723.9,2358.64l5.81-30.61c.66-3.49,1.25-7.36,1.64-10.28h4.55l-.81,5.46h.12c2.64-3.83,6.46-6.12,10.44-6.12,6.29,0,8.94,5.16,8.94,10.48,0,10.22-7.33,19.85-17,19.85-3.08,0-5.13-.68-6.25-1.3h-.12l-2.34,12.52h-4.96ZM3732.07,2341.9c1.28,1,3.16,1.6,5.54,1.6,6.42,0,11.79-7.97,11.79-15.56,0-3.04-1.34-6.71-5.56-6.71-3.92,0-8.78,4.46-10.29,12.57l-1.47,8.1Z'
				className='shape'
			/>
			<path
				d='M3783.93,2345.1c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM3778.42,2320.96c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M3794.99,2346.76l8.1-42.6h4.95l-5.1,26.71h.12c.88-1.02,1.95-2.12,2.71-2.92l10.23-10.2h6.15l-12.66,11.91,8.66,17.1h-5.48l-6.99-14.32-3.67,3.28-2.08,11.05h-4.94Z'
				className='shape'
			/>
			<path
				d='M3845.54,2346.76c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM3848.77,2321.46c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<polygon
				points='3893.49 2323.9 3893.9 2340.3 3911.14 2340.3 3894.15 2350.43 3894.56 2366.83 3883.65 2356.69 3866.66 2366.83 3876.91 2350.43 3866.01 2340.3 3883.25 2340.3 3893.49 2323.9'
				className='shape'
			/>
			<rect
				x='4038'
				y='2430.39'
				width='380.25'
				height='47.24'
				fill='none'
				className='shape'
			/>
			<path
				d='M4037.22,2470.67c1.32.56,2.95.88,5.09.88,4.24,0,6.94-2.24,8.28-9.4l5.18-27.28h4.96l-5.28,27.82c-1.78,9.47-5.73,13.27-13.31,13.27-2.44,0-4.98-.52-6-1.05l1.08-4.25Z'
				className='shape'
			/>
			<path
				d='M4087.45,2473.65c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM4081.95,2449.51c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M4136.25,2436.81c-.76-.37-1.78-.57-2.91-.57-3.96,0-5.88,3.86-6.73,8.66l-.25,1.39h6.47l-.76,3.91h-6.45l-4.76,25.11h-4.97l4.78-25.11h-11.76l-4.75,25.11h-4.95l4.76-25.11h-3.87l.75-3.91h3.88l.25-1.32c.67-3.45,1.94-7.08,4.36-9.5,1.7-1.68,3.98-2.77,7.03-2.77,1.52,0,2.8.38,3.75.86l-1.51,3.85c-.61-.33-1.5-.57-2.39-.57-3.96,0-5.52,4.04-6.32,8.24l-.23,1.2h11.78l.28-1.55c.72-4.03,2.15-7.76,4.75-10.13,1.84-1.66,4.37-2.57,6.89-2.57,2,0,3.31.38,3.99.78l-1.08,3.98Z'
				className='shape'
			/>
			<path
				d='M4157.77,2473.65c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM4152.26,2449.51c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M4168.82,2475.31l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.97,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.97Z'
				className='shape'
			/>
			<path
				d='M4192.94,2470.27c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.26-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.7,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.43,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M4247.72,2457.7c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM4225.41,2463.86c0,4.72,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M4256,2475.31l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.97Z'
				className='shape'
			/>
			<path
				d='M4336.68,2474c-2.28,1.02-5.95,1.94-10.49,1.94-10.18,0-16.41-6.47-16.41-16.79,0-7.61,3.08-14.87,8.63-19.49,4.18-3.53,9.33-5.42,15.24-5.42,4.5,0,7.73,1.12,8.76,1.94l-1.6,4.01c-1.5-.91-4.35-1.66-7.95-1.66-4.23,0-8.47,1.64-11.58,4.53-3.8,3.56-6.2,9.26-6.2,15.39,0,7.23,3.32,13.2,12.3,13.2,3.05,0,6.39-.61,8.64-1.73l.66,4.07Z'
				className='shape'
			/>
			<path
				d='M4346.6,2475.31l5.54-29.02h4.96l-5.54,29.02h-4.97ZM4353.06,2438.19c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.45,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M4378.12,2438.5l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.73.82,2.81,2.75,2.81.89,0,1.69-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.44l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
			<path
				d='M4395.71,2446.3l2.87,15.61c.64,3.34,1.02,5.48,1.31,7.65h.15c.76-1.86,1.62-3.89,3.08-7.11l7.43-16.15h5.28l-10.9,22.05c-3.11,6.29-6.05,11.38-10,15.27-3.24,3.27-6.79,4.65-8.44,5.01l-1.22-4.28c1.25-.44,3.35-1.25,5.32-2.79,1.96-1.51,4.06-3.85,5.61-6.7.25-.48.23-.81.15-1.32l-5.82-27.25h5.17Z'
				className='shape'
			/>
			<polygon
				points='4392.3 2387.63 4392.71 2404.02 4409.95 2404.02 4392.96 2414.15 4393.36 2430.55 4382.46 2420.42 4365.47 2430.55 4375.72 2414.15 4364.81 2404.02 4382.05 2404.02 4392.3 2387.63'
				className='shape'
			/>
			<rect x='4371' y='2139' width='305.9' height='45.28' fill='none' className='shape' />
			<path
				d='M4373.49,2176.69c2.2,1.48,5.23,2.58,8.61,2.58,4.55,0,8.74-2.72,8.74-7.59,0-3.01-1.69-5.24-5.92-7.56-5.16-2.79-8.05-6.03-8.05-10.37,0-7.24,6.22-11.87,13.65-11.87,3.95,0,6.89,1.15,8.28,2.1l-1.77,4.07c-1.27-.76-3.8-1.93-7.02-1.9-4.99,0-8.01,3.29-8.02,6.61,0,3.28,2.05,5.15,6.28,7.5,4.98,2.67,7.71,5.86,7.71,10.82,0,6.99-5.49,12.5-14.59,12.5-4.04,0-8.04-1.32-9.73-2.81l1.8-4.07Z'
				className='shape'
			/>
			<path
				d='M4402.96,2194.82l5.81-30.61c.66-3.49,1.25-7.36,1.63-10.28h4.55l-.81,5.46h.12c2.64-3.83,6.46-6.12,10.44-6.12,6.29,0,8.94,5.16,8.94,10.48,0,10.22-7.33,19.85-17,19.85-3.08,0-5.13-.68-6.25-1.3h-.12l-2.34,12.52h-4.96ZM4411.13,2178.07c1.28,1,3.16,1.6,5.54,1.6,6.42,0,11.79-7.97,11.79-15.56,0-3.04-1.34-6.71-5.56-6.71-3.92,0-8.78,4.46-10.29,12.57l-1.47,8.1Z'
				className='shape'
			/>
			<path
				d='M4441.88,2182.94l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.97,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.97Z'
				className='shape'
			/>
			<path
				d='M4465.7,2182.94l5.54-29.02h4.96l-5.54,29.02h-4.97ZM4472.16,2145.82c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.45,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M4484.24,2182.94l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.97Z'
				className='shape'
			/>
			<path
				d='M4521.33,2189.53c1.76,1.12,4.65,1.9,7.7,1.9,4.88,0,8.71-2.48,10.43-10.33l.96-4.34h-.15c-2.54,4.15-6.08,6.17-10.09,6.17-5.83,0-8.83-4.91-8.84-10.05-.02-9.88,7.19-19.61,18.42-19.61,3.37,0,7.03.94,9.31,2.02l-4.45,23.98c-1.17,6.15-2.83,10.39-5.85,12.99-2.9,2.51-6.82,3.22-10.13,3.22-3.53,0-6.88-.82-8.7-2.05l1.39-3.9ZM4543.64,2158.24c-.92-.46-2.72-.99-4.8-.99-7.26,0-12.26,7.59-12.29,14.76-.02,3.22,1.14,6.96,5.56,6.96s8.61-5.39,9.68-11.06l1.85-9.67Z'
				className='shape'
			/>
			<path
				d='M4558.01,2182.94l4.76-25.11h-3.87l.75-3.91h3.88l.27-1.49c1.44-7.93,6.32-12.75,13.88-12.75,2.72,0,5.55.78,6.58,1.54l-1.56,3.93c-1.23-.65-3.31-1.32-5.75-1.32-5.2,0-7.49,4-8.29,8.71l-.23,1.38h15.58l-5.53,29.02h-4.96l4.76-25.11h-10.58l-4.76,25.11h-4.92Z'
				className='shape'
			/>
			<path
				d='M4612.93,2181.28c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM4607.42,2157.14c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path d='M4623.99,2182.94l8.12-42.6h4.98l-8.13,42.6h-4.96Z' className='shape' />
			<path
				d='M4673.38,2140.34l-6.37,33.4c-.56,3.01-1.05,6.39-1.22,9.2h-4.56l.77-5.74h-.12c-2.65,4.11-6.3,6.4-10.47,6.4-5.6,0-8.67-4.6-8.67-10.56,0-10.32,7.67-19.77,17.95-19.77,1.82,0,3.87.39,5.12.99l2.6-13.92h4.95ZM4665.03,2158.47c-1-.68-2.66-1.23-4.75-1.23-6.96,0-12.38,7.42-12.38,15.12,0,3.51,1.2,7.16,5.48,7.16,3.82,0,8.46-4.37,9.71-10.9l1.94-10.15Z'
				className='shape'
			/>
			<polygon
				points='4712.33 2160.2 4712.74 2176.59 4729.98 2176.59 4712.99 2186.73 4713.4 2203.12 4702.49 2192.99 4685.5 2203.12 4695.75 2186.73 4684.84 2176.59 4702.08 2176.59 4712.33 2160.2'
				className='shape'
			/>
			<rect
				x='4824'
				y='2074.41'
				width='352.81'
				height='48.34'
				fill='none'
				className='shape'
			/>
			<path d='M4838.47,2079.45l-7.7,40.44h-4.97l7.69-40.44h4.98Z' className='shape' />
			<path
				d='M4844.48,2119.89l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.97Z'
				className='shape'
			/>
			<path
				d='M4912.18,2077.29l-6.37,33.4c-.56,3.01-1.05,6.39-1.22,9.2h-4.56l.77-5.74h-.12c-2.65,4.11-6.3,6.4-10.47,6.4-5.6,0-8.67-4.6-8.67-10.56,0-10.32,7.67-19.77,17.95-19.77,1.82,0,3.87.39,5.12.99l2.6-13.92h4.95ZM4903.83,2095.41c-1-.68-2.66-1.23-4.75-1.23-6.96,0-12.38,7.42-12.38,15.12,0,3.51,1.2,7.16,5.48,7.16,3.82,0,8.46-4.37,9.71-10.9l1.94-10.15Z'
				className='shape'
			/>
			<path
				d='M4917.62,2119.89l5.54-29.02h4.96l-5.54,29.02h-4.97ZM4924.08,2082.77c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.45,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M4955.4,2119.89c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM4958.63,2094.58c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M4972.4,2119.89l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.97Z'
				className='shape'
			/>
			<path
				d='M5037.08,2102.28c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM5014.77,2108.43c0,4.72,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M5042.74,2131.76l5.81-30.61c.66-3.49,1.25-7.36,1.63-10.28h4.55l-.81,5.46h.12c2.64-3.83,6.46-6.12,10.44-6.12,6.29,0,8.94,5.16,8.94,10.48,0,10.22-7.33,19.85-17,19.85-3.08,0-5.13-.68-6.25-1.3h-.12l-2.34,12.52h-4.96ZM5050.91,2115.02c1.28,1,3.16,1.6,5.54,1.6,6.42,0,11.79-7.97,11.79-15.56,0-3.04-1.34-6.71-5.56-6.71-3.92,0-8.78,4.46-10.29,12.57l-1.47,8.1Z'
				className='shape'
			/>
			<path
				d='M5109.68,2102.28c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM5087.37,2108.43c0,4.72,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path d='M5117.97,2119.89l8.12-42.6h4.98l-8.13,42.6h-4.96Z' className='shape' />
			<path
				d='M5136.5,2119.89l5.54-29.02h4.96l-5.54,29.02h-4.97ZM5142.96,2082.77c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.45,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M5155.28,2114.84c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.26-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.7,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.43,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<polygon
				points='5199.05 2115.15 5199.46 2131.55 5216.7 2131.55 5199.71 2141.68 5200.12 2158.07 5189.21 2147.94 5172.22 2158.07 5182.47 2141.68 5171.56 2131.55 5188.8 2131.55 5199.05 2115.15'
				className='shape'
			/>
			<rect
				x='5114'
				y='1618.46'
				width='220.56'
				height='51.64'
				fill='none'
				className='shape'
			/>
			<path
				d='M5123.56,1625.14h4.98l-6.89,36.11h16.31l-.83,4.33h-21.25l7.69-40.44Z'
				className='shape'
			/>
			<path
				d='M5166.08,1665.58c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM5169.31,1640.27c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M5183.08,1665.58l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.97Z'
				className='shape'
			/>
			<path
				d='M5220.16,1660.54c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.26-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.7,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.43,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M5247.1,1665.58l5.54-29.02h4.96l-5.54,29.02h-4.97ZM5253.56,1628.46c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.45,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M5265.64,1665.58l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.97Z'
				className='shape'
			/>
			<path
				d='M5302.73,1672.17c1.76,1.12,4.65,1.9,7.7,1.9,4.88,0,8.71-2.48,10.43-10.33l.96-4.34h-.15c-2.54,4.15-6.08,6.17-10.09,6.17-5.83,0-8.83-4.91-8.84-10.05-.02-9.88,7.19-19.61,18.42-19.61,3.37,0,7.03.94,9.31,2.02l-4.45,23.98c-1.17,6.15-2.83,10.39-5.85,12.99-2.9,2.51-6.82,3.22-10.13,3.22-3.53,0-6.88-.82-8.7-2.05l1.39-3.9ZM5325.03,1640.88c-.92-.46-2.72-.99-4.8-.99-7.26,0-12.26,7.59-12.29,14.76-.02,3.22,1.14,6.96,5.56,6.96s8.61-5.39,9.68-11.06l1.85-9.67Z'
				className='shape'
			/>
			<polygon
				points='5334.19 1577.89 5334.6 1594.29 5351.84 1594.29 5334.85 1604.42 5335.26 1620.82 5324.35 1610.68 5307.36 1620.82 5317.61 1604.42 5306.7 1594.29 5323.94 1594.29 5334.19 1577.89'
				className='shape'
			/>
			<rect x='5320' y='1956' width='279.34' height='52.49' fill='none' className='shape' />
			<path
				d='M5349.82,2002.24c-2.28,1.02-5.95,1.94-10.49,1.94-10.18,0-16.41-6.47-16.41-16.79,0-7.61,3.08-14.87,8.63-19.49,4.18-3.53,9.33-5.42,15.24-5.42,4.5,0,7.73,1.12,8.76,1.94l-1.6,4.01c-1.5-.91-4.35-1.66-7.95-1.66-4.23,0-8.47,1.64-11.58,4.53-3.8,3.56-6.2,9.26-6.2,15.39,0,7.23,3.32,13.2,12.3,13.2,3.05,0,6.39-.61,8.64-1.73l.66,4.07Z'
				className='shape'
			/>
			<path
				d='M5387.23,1985.94c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM5364.91,1992.1c0,4.72,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path d='M5395.52,2003.55l8.12-42.6h4.98l-8.13,42.6h-4.96Z' className='shape' />
			<path
				d='M5442.34,1974.53l-3.91,20.57c-.61,3.23-1.02,6.04-1.3,8.45h-4.49l.75-5.48h-.12c-2.59,3.78-6.4,6.14-10.24,6.14s-7.66-1.8-7.66-8.4c0-1.4.18-2.96.56-4.88l3.14-16.39h4.96l-3.08,16.17c-.31,1.61-.49,3.01-.49,4.25,0,3,1.23,5.05,4.64,5.05,3.63,0,8.25-4.23,9.45-10.6l2.83-14.88h4.96Z'
				className='shape'
			/>
			<path
				d='M5450.4,2003.55l3.85-20.57c.63-3.23,1.03-6.04,1.34-8.45h4.39l-.77,5.44h.14c2.72-4.05,6.37-6.1,10.22-6.1,4.42,0,6.57,2.8,6.78,6.47,2.6-4.2,6.29-6.41,10.66-6.47,3.36,0,7.05,2.14,7.05,7.61,0,1.34-.18,3.29-.48,4.93l-3.24,17.13h-4.86l3.13-16.71c.21-1.12.42-2.59.42-3.79,0-3.07-1.16-5.04-4.37-5.04-3.63,0-7.92,4.18-9.12,10.67l-2.77,14.87h-4.84l3.24-17.03c.24-1.3.39-2.41.39-3.54,0-2.44-.68-4.97-4.35-4.97s-8.15,4.8-9.27,10.96l-2.68,14.59h-4.86Z'
				className='shape'
			/>
			<path
				d='M5516.47,1960.95l-3.83,18.83.12.03c2.58-3.91,6.3-5.94,10.21-5.94,6.36,0,8.79,5.25,8.79,10.39,0,8.93-6.45,19.94-18.08,19.94-5.11,0-8.95-2.13-8.94-7.49,0-1.42.24-3.12.51-4.51l6.25-31.27h4.98ZM5510.18,1992.33c-.2.99-.38,2.14-.36,3.68.03,2.76,1.61,4.28,4.7,4.28,7.52,0,12.06-8.92,12.06-15.37,0-3.6-1.57-6.91-5.54-6.91-4.29,0-8.75,4.45-10.21,11.24l-.65,3.09Z'
				className='shape'
			/>
			<path
				d='M5568.28,1974.53l-3.91,20.57c-.61,3.23-1.02,6.04-1.3,8.45h-4.49l.75-5.48h-.12c-2.59,3.78-6.4,6.14-10.24,6.14s-7.66-1.8-7.66-8.4c0-1.4.18-2.96.56-4.88l3.14-16.39h4.96l-3.08,16.17c-.31,1.61-.49,3.01-.49,4.25,0,3,1.23,5.05,4.64,5.05,3.63,0,8.25-4.23,9.45-10.6l2.83-14.88h4.96Z'
				className='shape'
			/>
			<path
				d='M5576.58,1998.5c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.26-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.7,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.43,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<polygon
				points='5605.57 2001.99 5605.97 2018.38 5623.21 2018.38 5606.22 2028.51 5606.63 2044.91 5595.73 2034.78 5578.74 2044.91 5588.99 2028.51 5578.08 2018.38 5595.32 2018.38 5605.57 2001.99'
				className='shape'
			/>
			<rect
				x='5411.93'
				y='2410.61'
				width='263.07'
				height='46.39'
				fill='none'
				className='shape'
			/>
			<path
				d='M5421.49,2414.67h20.53l-.83,4.25h-15.52l-2.61,13.64h14.3l-.83,4.23h-14.3l-3.46,18.32h-4.97l7.69-40.44Z'
				className='shape'
			/>
			<path
				d='M5445.07,2455.11l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.97,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.97Z'
				className='shape'
			/>
			<path
				d='M5487.29,2455.11c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM5490.52,2429.8c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M5504.29,2455.11l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.97Z'
				className='shape'
			/>
			<path
				d='M5541.14,2455.11l8.1-42.6h4.95l-5.1,26.71h.12c.88-1.02,1.95-2.12,2.71-2.92l10.23-10.2h6.15l-12.66,11.91,8.66,17.1h-5.48l-6.99-14.32-3.67,3.28-2.08,11.05h-4.94Z'
				className='shape'
			/>
			<path
				d='M5573.97,2455.11l4.76-25.11h-3.87l.75-3.91h3.88l.28-1.55c.71-4.03,2.15-7.76,4.75-10.13,1.84-1.66,4.37-2.57,6.89-2.57,2,0,3.31.38,3.99.78l-1.08,3.98c-.77-.37-1.78-.57-2.91-.57-3.96,0-5.88,3.86-6.73,8.66l-.25,1.39h6.47l-.76,3.91h-6.45l-4.77,25.11h-4.94Z'
				className='shape'
			/>
			<path
				d='M5622.79,2437.5c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM5600.48,2443.66c0,4.72,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M5631.07,2455.11l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.97,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.97Z'
				className='shape'
			/>
			<path
				d='M5669.49,2418.29l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.73.82,2.81,2.75,2.81.89,0,1.69-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.44l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
			<polygon
				points='5400.11 2377.74 5400.52 2394.13 5417.76 2394.13 5400.77 2404.27 5401.18 2420.66 5390.27 2410.53 5373.28 2420.66 5383.53 2404.27 5372.62 2394.13 5389.86 2394.13 5400.11 2377.74'
				className='shape'
			/>
			<rect
				x='5847.01'
				y='2219'
				width='306.99'
				height='53.18'
				fill='none'
				className='shape'
			/>
			<path
				d='M5876.83,2265.58c-2.28,1.02-5.95,1.94-10.49,1.94-10.18,0-16.41-6.47-16.41-16.79,0-7.61,3.08-14.87,8.63-19.49,4.18-3.53,9.33-5.42,15.24-5.42,4.5,0,7.73,1.12,8.76,1.94l-1.6,4.01c-1.5-.91-4.35-1.66-7.95-1.66-4.23,0-8.47,1.64-11.58,4.53-3.8,3.56-6.2,9.26-6.2,15.39,0,7.23,3.32,13.2,12.3,13.2,3.05,0,6.39-.61,8.64-1.73l.66,4.07Z'
				className='shape'
			/>
			<path
				d='M5886.81,2266.89l8.1-42.6h4.98l-3.62,18.7h.12c2.49-3.53,5.99-5.77,10.37-5.77,3.29,0,7.22,1.99,7.22,7.77,0,1.55-.19,3.44-.48,4.91l-3.23,16.99h-4.97l3.18-16.77c.2-1.06.39-2.4.39-4,0-2.67-1.28-4.76-4.51-4.76-3.85,0-8.67,4.5-9.88,11l-2.71,14.54h-4.97Z'
				className='shape'
			/>
			<path
				d='M5942.89,2266.89c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM5946.12,2241.59c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M5959.89,2266.89l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.97,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.97Z'
				className='shape'
			/>
			<path d='M5983.72,2266.89l8.12-42.6h4.98l-8.13,42.6h-4.96Z' className='shape' />
			<path
				d='M6023.18,2265.23c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM6017.67,2241.08c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M6034.47,2261.85c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.26-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.7,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.43,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M6074.4,2230.08l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.73.82,2.81,2.75,2.81.89,0,1.69-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.44l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
			<path
				d='M6112.59,2249.28c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM6090.28,2255.44c0,4.72,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M6120.87,2266.89l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.97Z'
				className='shape'
			/>
			<polygon
				points='5836.29 2272.26 5836.7 2288.66 5853.94 2288.66 5836.95 2298.79 5837.36 2315.19 5826.45 2305.05 5809.46 2315.19 5819.71 2298.79 5808.8 2288.66 5826.04 2288.66 5836.29 2272.26'
				className='shape'
			/>
			<rect
				x='6128'
				y='2360.07'
				width='285.47'
				height='46.14'
				fill='none'
				className='shape'
			/>
			<path
				d='M6137.47,2364.6c2.47-.56,5.81-.86,8.82-.86,4.04,0,7.5.95,9.66,2.93,1.87,1.62,2.99,3.94,2.99,6.69,0,5.87-4.5,10.26-9.6,11.69v.15c2.81.94,4.15,3.97,4.45,8.12.45,5.64.73,9.5,1.26,11.13h-5.15c-.23-.86-.65-5.09-.94-9.75-.32-5.57-2.36-7.86-6.38-7.86h-4.42l-3.34,17.62h-4.93l7.58-39.84ZM6138.92,2382.96h4.46c6.31,0,10.37-4.12,10.37-8.97,0-4.33-3.26-6.27-7.81-6.27-1.99,0-3.26.17-4.19.43l-2.82,14.81Z'
				className='shape'
			/>
			<path
				d='M6166.42,2404.45l5.54-29.02h4.96l-5.54,29.02h-4.97ZM6172.88,2367.33c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.45,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M6204.92,2403.3c-1.48.73-4.49,1.78-8.43,1.78-7.46,0-11.16-5.06-11.16-11.22,0-9.9,7.37-19.07,17.8-19.07,2.7,0,5.15.79,6.03,1.32l-1.42,3.95c-1.15-.55-2.74-1.09-4.93-1.09-7.53,0-12.3,7.43-12.3,14.27,0,4.72,2.47,7.76,7.23,7.76,2.95,0,5.22-.91,6.7-1.62l.48,3.93Z'
				className='shape'
			/>
			<path
				d='M6215.14,2404.45l8.1-42.6h4.98l-3.62,18.7h.12c2.49-3.53,5.99-5.77,10.37-5.77,3.29,0,7.22,1.99,7.22,7.77,0,1.55-.19,3.44-.48,4.91l-3.23,16.99h-4.97l3.18-16.77c.2-1.06.39-2.4.39-4,0-2.67-1.28-4.76-4.51-4.76-3.85,0-8.67,4.5-9.88,11l-2.71,14.54h-4.97Z'
				className='shape'
			/>
			<path
				d='M6251.98,2404.45l3.85-20.57c.63-3.23,1.03-6.04,1.34-8.45h4.39l-.77,5.44h.14c2.72-4.05,6.37-6.1,10.22-6.1,4.42,0,6.57,2.8,6.78,6.47,2.6-4.2,6.29-6.41,10.66-6.47,3.36,0,7.05,2.14,7.05,7.61,0,1.34-.18,3.29-.48,4.93l-3.24,17.13h-4.86l3.13-16.71c.21-1.12.42-2.59.42-3.79,0-3.07-1.16-5.04-4.37-5.04-3.63,0-7.92,4.18-9.12,10.67l-2.77,14.87h-4.84l3.24-17.03c.24-1.3.39-2.41.39-3.54,0-2.44-.68-4.97-4.35-4.97s-8.15,4.8-9.27,10.96l-2.68,14.59h-4.86Z'
				className='shape'
			/>
			<path
				d='M6333.1,2386.84c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM6310.79,2392.99c0,4.72,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M6341.38,2404.45l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.97Z'
				className='shape'
			/>
			<path
				d='M6409.08,2361.85l-6.37,33.4c-.56,3.01-1.05,6.39-1.22,9.2h-4.56l.77-5.74h-.12c-2.65,4.11-6.3,6.4-10.47,6.4-5.6,0-8.67-4.6-8.67-10.56,0-10.32,7.67-19.77,17.95-19.77,1.82,0,3.87.39,5.12.99l2.6-13.92h4.95ZM6400.73,2379.97c-1-.68-2.66-1.23-4.75-1.23-6.96,0-12.38,7.42-12.38,15.12,0,3.51,1.2,7.16,5.48,7.16,3.82,0,8.46-4.37,9.71-10.9l1.94-10.15Z'
				className='shape'
			/>
			<polygon
				points='6437.28 2314.01 6437.68 2330.41 6454.92 2330.41 6437.93 2340.54 6438.34 2356.94 6427.43 2346.8 6410.45 2356.94 6420.69 2340.54 6409.79 2330.41 6427.03 2330.41 6437.28 2314.01'
				className='shape'
			/>
			<rect
				x='6102'
				y='2607.28'
				width='210.39'
				height='54.93'
				fill='none'
				className='shape'
			/>
			<path
				d='M6111.47,2616.2c2.47-.56,5.81-.86,8.82-.86,4.04,0,7.5.95,9.66,2.93,1.87,1.62,2.99,3.94,2.99,6.69,0,5.87-4.5,10.26-9.6,11.69v.15c2.81.94,4.15,3.97,4.45,8.12.45,5.64.73,9.5,1.26,11.13h-5.15c-.23-.86-.65-5.09-.94-9.75-.32-5.57-2.36-7.86-6.38-7.86h-4.42l-3.34,17.62h-4.93l7.58-39.84ZM6112.92,2634.56h4.46c6.31,0,10.37-4.12,10.37-8.97,0-4.33-3.26-6.27-7.81-6.27-1.99,0-3.26.17-4.19.43l-2.82,14.81Z'
				className='shape'
			/>
			<path
				d='M6158.88,2656.05c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM6162.11,2630.74c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path d='M6175.78,2656.05l8.12-42.6h4.98l-8.13,42.6h-4.96Z' className='shape' />
			<path
				d='M6215.23,2654.38c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM6209.72,2630.24c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M6226.28,2656.05l5.54-29.02h4.96l-5.54,29.02h-4.97ZM6232.74,2618.93c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.45,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M6245.07,2662.64c1.76,1.12,4.65,1.9,7.7,1.9,4.88,0,8.71-2.48,10.43-10.33l.96-4.34h-.15c-2.54,4.15-6.08,6.17-10.09,6.17-5.83,0-8.83-4.91-8.84-10.05-.02-9.88,7.19-19.61,18.42-19.61,3.37,0,7.03.94,9.31,2.02l-4.45,23.98c-1.17,6.15-2.83,10.39-5.85,12.99-2.9,2.51-6.82,3.22-10.13,3.22-3.53,0-6.88-.82-8.7-2.05l1.39-3.9ZM6267.37,2631.34c-.92-.46-2.72-.99-4.8-.99-7.26,0-12.26,7.59-12.29,14.76-.02,3.22,1.14,6.96,5.56,6.96s8.61-5.39,9.68-11.06l1.85-9.67Z'
				className='shape'
			/>
			<path
				d='M6281.06,2656.05l8.1-42.6h4.98l-3.62,18.7h.12c2.49-3.53,5.99-5.77,10.37-5.77,3.29,0,7.22,1.99,7.22,7.77,0,1.55-.19,3.44-.48,4.91l-3.23,16.99h-4.97l3.18-16.77c.2-1.06.39-2.4.39-4,0-2.67-1.28-4.76-4.51-4.76-3.85,0-8.67,4.5-9.88,11l-2.71,14.54h-4.97Z'
				className='shape'
			/>
			<polygon
				points='6334 2659 6334.41 2675.4 6351.64 2675.4 6334.66 2685.53 6335.06 2701.93 6324.16 2691.79 6307.17 2701.93 6317.42 2685.53 6306.51 2675.4 6323.75 2675.4 6334 2659'
				className='shape'
			/>
			<rect
				x='6092'
				y='1776.67'
				width='302.79'
				height='51.64'
				fill='none'
				className='shape'
			/>
			<path
				d='M6106.55,1783.35l-3.27,17.06h18.6l3.26-17.06h4.99l-7.7,40.44h-4.98l3.59-19h-18.61l-3.59,19h-4.96l7.69-40.44h4.98Z'
				className='shape'
			/>
			<path
				d='M6155.36,1823.79c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM6158.59,1798.48c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M6172.36,1823.79l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.97,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.97Z'
				className='shape'
			/>
			<path
				d='M6196.18,1823.79l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.97,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.97Z'
				className='shape'
			/>
			<path
				d='M6220,1823.79l5.54-29.02h4.96l-5.54,29.02h-4.97ZM6226.46,1786.67c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.45,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M6238.78,1818.75c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.26-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.7,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.43,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M6278.51,1781.19l-3.83,18.83.12.03c2.58-3.91,6.3-5.94,10.21-5.94,6.36,0,8.79,5.25,8.79,10.39,0,8.93-6.45,19.94-18.08,19.94-5.11,0-8.95-2.13-8.94-7.49,0-1.42.24-3.12.51-4.51l6.25-31.26h4.98ZM6272.22,1812.57c-.2.99-.38,2.14-.36,3.68.03,2.76,1.61,4.28,4.7,4.28,7.52,0,12.06-8.92,12.06-15.37,0-3.6-1.57-6.91-5.54-6.91-4.28,0-8.75,4.45-10.21,11.24l-.65,3.09Z'
				className='shape'
			/>
			<path
				d='M6330.32,1794.77l-3.91,20.57c-.61,3.23-1.02,6.04-1.3,8.45h-4.49l.75-5.48h-.12c-2.59,3.78-6.4,6.14-10.24,6.14s-7.66-1.8-7.66-8.4c0-1.4.18-2.96.56-4.88l3.14-16.39h4.96l-3.08,16.17c-.31,1.61-.49,3.01-.49,4.25,0,3,1.23,5.05,4.64,5.05,3.63,0,8.25-4.23,9.45-10.6l2.83-14.88h4.96Z'
				className='shape'
			/>
			<path
				d='M6338.38,1823.79l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.97,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.97Z'
				className='shape'
			/>
			<path
				d='M6362.03,1830.38c1.76,1.12,4.65,1.9,7.7,1.9,4.88,0,8.71-2.48,10.43-10.33l.96-4.34h-.15c-2.54,4.15-6.08,6.17-10.09,6.17-5.83,0-8.83-4.91-8.84-10.05-.02-9.88,7.19-19.61,18.42-19.61,3.37,0,7.03.94,9.31,2.02l-4.45,23.98c-1.17,6.15-2.83,10.39-5.85,12.99-2.9,2.51-6.82,3.22-10.13,3.22-3.53,0-6.88-.82-8.7-2.05l1.39-3.9ZM6384.33,1799.09c-.92-.46-2.72-.99-4.8-.99-7.26,0-12.26,7.59-12.29,14.76-.02,3.22,1.14,6.96,5.56,6.96s8.61-5.39,9.68-11.06l1.85-9.67Z'
				className='shape'
			/>
			<polygon
				points='6410.91 1826.19 6411.31 1842.59 6428.55 1842.59 6411.56 1852.72 6411.97 1869.12 6401.07 1858.99 6384.08 1869.12 6394.33 1852.72 6383.42 1842.59 6400.66 1842.59 6410.91 1826.19'
				className='shape'
			/>
			<rect
				x='6699.59'
				y='1806.33'
				width='216.41'
				height='43.95'
				fill='none'
				className='shape'
			/>
			<path
				d='M6715.32,1813.49h-11.81l.85-4.32h28.64l-.84,4.32h-11.88l-6.84,36.11h-4.96l6.84-36.11Z'
				className='shape'
			/>
			<path
				d='M6731.47,1849.61l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.97,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.97Z'
				className='shape'
			/>
			<path
				d='M6775.92,1847.94c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM6770.42,1823.8c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M6786.97,1849.61l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.97Z'
				className='shape'
			/>
			<path
				d='M6836.8,1812.79l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.73.82,2.81,2.75,2.81.89,0,1.69-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.44l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
			<path
				d='M6875,1832c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM6852.68,1838.16c0,4.72,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M6883.27,1849.61l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.97Z'
				className='shape'
			/>
			<polygon
				points='6692.17 1775.66 6692.58 1792.05 6709.82 1792.05 6692.83 1802.18 6693.24 1818.58 6682.33 1808.45 6665.34 1818.58 6675.59 1802.18 6664.68 1792.05 6681.92 1792.05 6692.17 1775.66'
				className='shape'
			/>
			<rect x='6497' y='1364.66' width='196' height='52.34' fill='none' className='shape' />
			<path
				d='M6507.07,1399.34l-6.43,12.79h-5.24l20.89-40.44h5.88l5.59,40.44h-5.1l-1.63-12.79h-13.96ZM6520.66,1395.38l-1.57-11.68c-.22-2.11-.52-5.07-.72-7.44h-.14c-1.08,2.41-2.08,4.93-3.31,7.37l-6.03,11.76h11.77Z'
				className='shape'
			/>
			<path d='M6537.65,1412.13l8.12-42.6h4.98l-8.13,42.6h-4.96Z' className='shape' />
			<path
				d='M6568.97,1369.53l-3.83,18.83.12.03c2.58-3.91,6.3-5.94,10.21-5.94,6.36,0,8.79,5.25,8.79,10.39,0,8.93-6.45,19.94-18.08,19.94-5.11,0-8.95-2.13-8.94-7.49,0-1.42.24-3.12.51-4.51l6.25-31.27h4.98ZM6562.68,1400.91c-.2.99-.38,2.14-.36,3.68.03,2.76,1.61,4.28,4.7,4.28,7.52,0,12.06-8.92,12.06-15.37,0-3.6-1.57-6.91-5.54-6.91-4.28,0-8.75,4.45-10.21,11.24l-.65,3.09Z'
				className='shape'
			/>
			<path
				d='M6611.72,1412.13c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM6614.95,1386.83c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M6628.72,1412.13l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.97Z'
				className='shape'
			/>
			<path
				d='M6671.53,1383.11l2.87,15.61c.64,3.34,1.02,5.48,1.31,7.65h.15c.76-1.86,1.62-3.9,3.08-7.11l7.43-16.15h5.28l-10.9,22.05c-3.11,6.29-6.05,11.38-10,15.27-3.24,3.27-6.79,4.65-8.44,5.01l-1.22-4.28c1.25-.44,3.35-1.25,5.32-2.79,1.96-1.51,4.06-3.85,5.61-6.7.25-.48.23-.81.15-1.32l-5.82-27.25h5.17Z'
				className='shape'
			/>
			<polygon
				points='6715.24 1329.59 6715.65 1345.98 6732.89 1345.98 6715.9 1356.12 6716.31 1372.51 6705.4 1362.38 6688.41 1372.51 6698.66 1356.12 6687.76 1345.98 6705 1345.98 6715.24 1329.59'
				className='shape'
			/>
			<rect
				x='6916.03'
				y='1484.42'
				width='248.97'
				height='48.58'
				fill='none'
				className='shape'
			/>
			<path
				d='M6930.58,1489.57l-3.27,17.05h18.6l3.26-17.05h4.99l-7.7,40.44h-4.98l3.59-19h-18.61l-3.59,19h-4.96l7.69-40.44h4.98Z'
				className='shape'
			/>
			<path
				d='M6979.4,1530.01c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM6982.62,1504.71c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M6996.4,1530.01l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.97,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.97Z'
				className='shape'
			/>
			<path
				d='M7034.82,1493.2l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.73.82,2.81,2.75,2.81.89,0,1.69-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.44l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
			<path
				d='M7046.1,1530.01l4.76-25.11h-3.87l.75-3.91h3.88l.28-1.55c.71-4.03,2.15-7.76,4.75-10.13,1.84-1.66,4.37-2.57,6.89-2.57,2,0,3.31.38,3.99.78l-1.08,3.98c-.77-.37-1.78-.57-2.91-.57-3.96,0-5.88,3.86-6.73,8.66l-.25,1.39h6.47l-.76,3.91h-6.45l-4.77,25.11h-4.94Z'
				className='shape'
			/>
			<path
				d='M7094.92,1512.4c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM7072.6,1518.56c0,4.72,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M7103.19,1530.01l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.97,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.97Z'
				className='shape'
			/>
			<path
				d='M7157.57,1487.41l-6.37,33.4c-.56,3.01-1.05,6.39-1.22,9.2h-4.56l.77-5.74h-.12c-2.65,4.11-6.3,6.4-10.47,6.4-5.6,0-8.67-4.6-8.67-10.56,0-10.32,7.67-19.77,17.95-19.77,1.82,0,3.87.39,5.12.99l2.6-13.92h4.95ZM7149.22,1505.54c-1-.68-2.66-1.23-4.75-1.23-6.96,0-12.38,7.42-12.38,15.12,0,3.51,1.2,7.16,5.48,7.16,3.82,0,8.46-4.37,9.71-10.9l1.94-10.15Z'
				className='shape'
			/>
			<polygon
				points='6904.22 1446.05 6904.63 1462.44 6921.86 1462.44 6904.88 1472.58 6905.28 1488.97 6894.38 1478.84 6877.39 1488.97 6887.64 1472.58 6876.73 1462.44 6893.97 1462.44 6904.22 1446.05'
				className='shape'
			/>
			<rect
				x='7086.33'
				y='1417.4'
				width='311.67'
				height='61.53'
				fill='none'
				className='shape'
			/>
			<path
				d='M7095.79,1429.62c2.27-.53,5.5-.86,8.76-.86,3.9,0,7.65.94,9.91,3.11,1.91,1.77,2.93,4.13,2.93,7.32,0,4.51-2.21,8.31-4.84,10.52-3.12,2.63-7.7,3.87-12.25,3.87-1.52,0-2.84-.11-4.12-.32l-3.08,16.21h-4.89l7.59-39.84ZM7096.95,1449.06c1.41.3,2.56.4,4.03.4,6.82,0,11.4-4.24,11.4-9.93,0-4.83-3.44-6.73-8.05-6.73-1.97,0-3.46.17-4.36.43l-3.02,15.83Z'
				className='shape'
			/>
			<path
				d='M7122.59,1469.46l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.97,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.97Z'
				className='shape'
			/>
			<path
				d='M7173.96,1451.85c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM7151.64,1458.01c0,4.72,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M7188.27,1440.45l2.5,16.52c.44,3.3.81,5.54.93,7.13h.17c.64-1.54,1.41-3.45,3.09-6.76l8.86-16.89h5.45l-16.15,29.02h-4.9l-5.01-29.02h5.07Z'
				className='shape'
			/>
			<path
				d='M7213.91,1469.46l5.54-29.02h4.96l-5.54,29.02h-4.97ZM7220.37,1432.34c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.46,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M7263.31,1426.86l-6.37,33.4c-.56,3.01-1.05,6.39-1.22,9.2h-4.56l.77-5.74h-.12c-2.65,4.11-6.3,6.4-10.47,6.4-5.6,0-8.67-4.6-8.67-10.56,0-10.32,7.67-19.77,17.95-19.77,1.82,0,3.87.39,5.12.99l2.6-13.92h4.95ZM7254.96,1444.99c-1-.68-2.66-1.23-4.75-1.23-6.96,0-12.38,7.42-12.38,15.12,0,3.51,1.2,7.16,5.48,7.16,3.82,0,8.46-4.37,9.71-10.9l1.94-10.15Z'
				className='shape'
			/>
			<path
				d='M7289.68,1467.8c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM7284.17,1443.66c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M7300.73,1469.46l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.97Z'
				className='shape'
			/>
			<path
				d='M7357.53,1468.31c-1.48.73-4.49,1.78-8.43,1.78-7.46,0-11.16-5.06-11.16-11.22,0-9.9,7.37-19.07,17.8-19.07,2.7,0,5.15.79,6.03,1.32l-1.42,3.95c-1.15-.55-2.74-1.09-4.93-1.09-7.53,0-12.3,7.43-12.3,14.27,0,4.72,2.47,7.76,7.23,7.76,2.95,0,5.22-.91,6.7-1.62l.48,3.93Z'
				className='shape'
			/>
			<path
				d='M7388.14,1467.8c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM7382.63,1443.66c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<polygon
				points='7067.92 1401 7068.33 1417.4 7085.57 1417.4 7068.58 1427.53 7068.99 1443.93 7058.08 1433.79 7041.09 1443.93 7051.34 1427.53 7040.44 1417.4 7057.68 1417.4 7067.92 1401'
				className='shape'
			/>
			<rect
				x='6455'
				y='1005.39'
				width='309.41'
				height='42.85'
				fill='none'
				className='shape'
			/>
			<path
				d='M6490.74,1047.99l2.9-21.84c.53-3.86,1.42-9.78,2.19-13.68h-.19c-1.87,4.08-4.12,8.89-6.33,13.03l-12.01,22.24h-3.8l-2.99-21.78c-.62-4.64-1.03-9.34-1.3-13.48h-.13c-.85,3.74-2.12,9.84-3.08,13.69l-5.5,21.83h-4.68l10.47-40.44h6.35l3.2,23.19c.4,3.44.87,7.13.97,10.14h.18c1.23-3.01,2.96-6.63,4.71-10l12.52-23.33h6.51l-5.13,40.44h-4.84Z'
				className='shape'
			/>
			<path
				d='M6536.15,1030.38c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM6513.83,1036.54c0,4.72,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M6544.42,1047.99l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.97Z'
				className='shape'
			/>
			<path
				d='M6594.25,1011.18l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.73.82,2.81,2.75,2.81.89,0,1.69-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.44l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
			<path
				d='M6602.22,1059.87l5.81-30.61c.66-3.49,1.25-7.36,1.63-10.28h4.55l-.81,5.46h.12c2.64-3.83,6.46-6.12,10.44-6.12,6.29,0,8.94,5.16,8.94,10.48,0,10.22-7.33,19.85-17,19.85-3.08,0-5.13-.68-6.25-1.3h-.12l-2.34,12.52h-4.96ZM6610.39,1043.12c1.28,1,3.16,1.6,5.54,1.6,6.42,0,11.79-7.97,11.79-15.56,0-3.04-1.34-6.71-5.56-6.71-3.92,0-8.78,4.46-10.29,12.57l-1.47,8.1Z'
				className='shape'
			/>
			<path
				d='M6662.25,1046.32c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM6656.74,1022.18c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path d='M6673.31,1047.99l8.12-42.6h4.98l-8.13,42.6h-4.96Z' className='shape' />
			<path
				d='M6691.84,1047.99l5.54-29.02h4.96l-5.54,29.02h-4.97ZM6698.3,1010.87c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.46,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M6731.3,1046.32c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM6725.8,1022.18c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M6742.36,1047.99l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.97,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.97Z'
				className='shape'
			/>
			<polygon
				points='6799.84 1024.15 6800.25 1040.55 6817.49 1040.55 6800.5 1050.68 6800.91 1067.08 6790 1056.94 6773.01 1067.08 6783.26 1050.68 6772.36 1040.55 6789.6 1040.55 6799.84 1024.15'
				className='shape'
			/>
			<rect x='6708' y='1140' width='235.5' height='51.07' fill='none' className='shape' />
			<path
				d='M6737.82,1185.53c-2.28,1.02-5.95,1.94-10.49,1.94-10.18,0-16.41-6.47-16.41-16.79,0-7.61,3.08-14.87,8.63-19.49,4.18-3.53,9.33-5.42,15.24-5.42,4.5,0,7.73,1.12,8.76,1.94l-1.6,4.01c-1.5-.91-4.35-1.66-7.95-1.66-4.23,0-8.47,1.64-11.58,4.53-3.8,3.56-6.2,9.26-6.2,15.39,0,7.23,3.32,13.2,12.3,13.2,3.05,0,6.39-.61,8.64-1.73l.66,4.07Z'
				className='shape'
			/>
			<path
				d='M6775.23,1169.23c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM6752.91,1175.38c0,4.72,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M6783.5,1186.83l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.97Z'
				className='shape'
			/>
			<path
				d='M6840.3,1185.68c-1.48.73-4.49,1.78-8.43,1.78-7.46,0-11.16-5.06-11.16-11.22,0-9.9,7.37-19.07,17.8-19.07,2.7,0,5.15.79,6.03,1.32l-1.42,3.95c-1.15-.55-2.74-1.09-4.93-1.09-7.53,0-12.3,7.43-12.3,14.27,0,4.72,2.47,7.76,7.23,7.76,2.95,0,5.22-.91,6.7-1.62l.48,3.93Z'
				className='shape'
			/>
			<path
				d='M6877.83,1169.23c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM6855.51,1175.38c0,4.72,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M6886.1,1186.83l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.97,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.97Z'
				className='shape'
			/>
			<path
				d='M6940.48,1144.24l-6.37,33.4c-.56,3.01-1.05,6.39-1.22,9.2h-4.56l.77-5.74h-.12c-2.65,4.11-6.3,6.4-10.47,6.4-5.6,0-8.67-4.6-8.67-10.56,0-10.32,7.67-19.78,17.95-19.78,1.82,0,3.87.39,5.12.99l2.6-13.92h4.95ZM6932.13,1162.36c-1-.68-2.66-1.23-4.75-1.23-6.96,0-12.38,7.42-12.38,15.12,0,3.51,1.2,7.16,5.48,7.16,3.82,0,8.46-4.37,9.71-10.9l1.94-10.15Z'
				className='shape'
			/>
			<polygon
				points='6978.93 1166.98 6979.34 1183.38 6996.58 1183.38 6979.59 1193.51 6979.99 1209.91 6969.09 1199.77 6952.1 1209.91 6962.35 1193.51 6951.44 1183.38 6968.68 1183.38 6978.93 1166.98'
				className='shape'
			/>
			<rect
				x='7155.31'
				y='943.97'
				width='199.69'
				height='49.44'
				fill='none'
				className='shape'
			/>
			<path
				d='M7165.38,977.2l-6.43,12.79h-5.24l20.89-40.44h5.88l5.59,40.44h-5.1l-1.63-12.79h-13.96ZM7178.97,973.24l-1.57-11.68c-.22-2.11-.52-5.07-.72-7.44h-.14c-1.08,2.41-2.08,4.93-3.31,7.37l-6.03,11.76h11.77Z'
				className='shape'
			/>
			<path
				d='M7195.55,996.59c1.76,1.12,4.65,1.9,7.7,1.9,4.88,0,8.71-2.48,10.43-10.33l.96-4.34h-.15c-2.54,4.15-6.08,6.17-10.09,6.17-5.83,0-8.83-4.91-8.84-10.05-.02-9.88,7.19-19.61,18.42-19.61,3.37,0,7.03.94,9.31,2.02l-4.45,23.98c-1.17,6.15-2.83,10.39-5.85,12.99-2.9,2.51-6.82,3.22-10.13,3.22-3.53,0-6.88-.82-8.7-2.05l1.39-3.9ZM7217.85,965.29c-.92-.46-2.72-.99-4.8-.99-7.26,0-12.26,7.59-12.29,14.76-.02,3.22,1.14,6.96,5.56,6.96s8.61-5.39,9.68-11.06l1.85-9.67Z'
				className='shape'
			/>
			<path
				d='M7259.83,960.98l-3.91,20.57c-.61,3.23-1.02,6.04-1.3,8.45h-4.49l.75-5.48h-.12c-2.59,3.78-6.4,6.14-10.24,6.14s-7.66-1.8-7.66-8.4c0-1.4.18-2.96.56-4.88l3.14-16.39h4.96l-3.08,16.17c-.31,1.61-.49,3.01-.49,4.25,0,3,1.23,5.05,4.64,5.05,3.63,0,8.25-4.23,9.45-10.6l2.83-14.88h4.96Z'
				className='shape'
			/>
			<path
				d='M7268.13,984.95c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.27-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.7,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.43,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M7308.06,953.18l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.73.82,2.81,2.75,2.81.89,0,1.69-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.44l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
			<path
				d='M7337.83,989.99c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM7341.06,964.69c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<polygon
				points='7142.63 913.18 7143.04 929.58 7160.28 929.58 7143.29 939.71 7143.7 956.11 7132.79 945.97 7115.8 956.11 7126.05 939.71 7115.15 929.58 7132.39 929.58 7142.63 913.18'
				className='shape'
			/>
			<rect
				x='7107.21'
				y='1262'
				width='195.79'
				height='49.92'
				fill='none'
				className='shape'
			/>
			<path
				d='M7116.64,1268.39c2.47-.5,5.39-.84,8.67-.84,4.17,0,7.18.84,9.33,2.77,1.86,1.52,2.9,3.67,2.9,6.3,0,5.11-4.12,8.9-8.71,10.09v.16c3.65,1.07,6.67,4.11,6.63,8.98,0,4.14-2.19,7.39-4.84,9.36-3.21,2.41-7.67,3.32-13.09,3.32-3.47,0-6.49-.21-8.38-.57l7.48-39.57ZM7114.73,1304.24c1.26.2,2.73.26,4.09.26,5.89.03,11.42-2.43,11.42-8.9,0-4.75-4.01-6.83-8.54-6.83h-4.05l-2.92,15.47ZM7118.43,1284.99h3.7c5.8,0,10.27-3.01,10.27-7.92,0-3.9-2.94-5.56-7.34-5.56-1.83,0-3.36.13-4.13.37l-2.5,13.11Z'
				className='shape'
			/>
			<path
				d='M7172.87,1290.65c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM7150.56,1296.81c0,4.72,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M7181.39,1303.22c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.27-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.7,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.43,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M7221.31,1271.45l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.73.82,2.81,2.75,2.81.89,0,1.69-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.44l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
			<path
				d='M7259.51,1290.65c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM7237.2,1296.81c0,4.72,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M7267.78,1308.26l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.97Z'
				className='shape'
			/>
			<polygon
				points='7093.19 1305.42 7093.6 1321.81 7110.84 1321.81 7093.85 1331.94 7094.26 1348.34 7083.35 1338.21 7066.36 1348.34 7076.61 1331.94 7065.71 1321.81 7082.95 1321.81 7093.19 1305.42'
				className='shape'
			/>
			<rect x='6173' y='2042.55' width='282.3' height='47.24' fill='none' className='shape' />
			<path
				d='M6183.07,2074.68l-6.43,12.79h-5.24l20.89-40.44h5.88l5.59,40.44h-5.1l-1.63-12.79h-13.96ZM6196.66,2070.72l-1.57-11.68c-.22-2.11-.52-5.07-.72-7.44h-.14c-1.08,2.41-2.08,4.93-3.31,7.37l-6.03,11.76h11.77Z'
				className='shape'
			/>
			<path
				d='M6214,2087.47l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.97Z'
				className='shape'
			/>
			<path
				d='M6250.84,2087.47l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.97Z'
				className='shape'
			/>
			<path
				d='M6306.92,2087.47c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM6310.15,2062.17c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M6321.3,2099.35l5.81-30.61c.66-3.49,1.25-7.36,1.63-10.28h4.55l-.81,5.46h.12c2.64-3.83,6.46-6.12,10.44-6.12,6.29,0,8.94,5.16,8.94,10.48,0,10.22-7.33,19.85-17,19.85-3.08,0-5.13-.68-6.25-1.3h-.12l-2.34,12.52h-4.96ZM6329.47,2082.61c1.28,1,3.16,1.6,5.54,1.6,6.42,0,11.79-7.97,11.79-15.56,0-3.04-1.34-6.71-5.56-6.71-3.92,0-8.78,4.46-10.29,12.57l-1.47,8.1Z'
				className='shape'
			/>
			<path
				d='M6388.24,2069.87c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM6365.93,2076.02c0,4.72,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path d='M6396.53,2087.47l8.12-42.6h4.98l-8.13,42.6h-4.96Z' className='shape' />
			<path
				d='M6415.06,2087.47l5.54-29.02h4.96l-5.54,29.02h-4.97ZM6421.52,2050.36c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.45,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M6433.84,2082.43c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.26-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.7,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.43,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<polygon
				points='6477.54 2006.38 6477.95 2022.78 6495.19 2022.78 6478.2 2032.91 6478.6 2049.3 6467.7 2039.17 6450.71 2049.3 6460.96 2032.91 6450.05 2022.78 6467.29 2022.78 6477.54 2006.38'
				className='shape'
			/>
			<rect
				x='6659.65'
				y='2011.79'
				width='168.35'
				height='46.14'
				fill='none'
				className='shape'
			/>
			<path
				d='M6669.12,2016.26c3.11-.54,6.51-.81,10.05-.81,6.74,0,11.89,1.91,14.88,5.38,2.18,2.26,3.78,5.86,3.8,10.96,0,7.32-2.91,14.57-8.11,19.01-4.68,3.93-10.57,5.63-18.33,5.63-3.53,0-7.19-.2-9.81-.51l7.53-39.66ZM6667.31,2052.02c1.81.24,3.72.28,5.22.28,6.43,0,11.1-1.89,14.47-5.37,3.64-3.71,5.51-9.23,5.51-14.92,0-7.16-3.5-12.51-13.58-12.51-1.81,0-4.07.11-5.51.42l-6.11,32.09Z'
				className='shape'
			/>
			<path
				d='M6733.48,2038.55c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM6711.16,2044.71c0,4.72,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M6747.79,2027.15l2.5,16.52c.44,3.3.81,5.54.93,7.13h.17c.64-1.54,1.41-3.45,3.09-6.76l8.86-16.89h5.45l-16.15,29.02h-4.9l-5.01-29.02h5.07Z'
				className='shape'
			/>
			<path
				d='M6793.88,2054.5c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM6788.38,2030.36c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M6804.93,2056.16l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.97,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.97Z'
				className='shape'
			/>
			<polygon
				points='6648.94 1977.81 6649.34 1994.21 6666.58 1994.21 6649.59 2004.34 6650 2020.74 6639.09 2010.61 6622.11 2020.74 6632.35 2004.34 6621.45 1994.21 6638.69 1994.21 6648.94 1977.81'
				className='shape'
			/>
			<rect
				x='4432'
				y='1597.58'
				width='242.01'
				height='46.42'
				fill='none'
				className='shape'
			/>
			<path
				d='M4467.74,1642.09l2.9-21.84c.53-3.86,1.42-9.78,2.19-13.68h-.19c-1.87,4.08-4.12,8.89-6.33,13.03l-12.01,22.24h-3.8l-2.99-21.78c-.62-4.64-1.03-9.34-1.3-13.48h-.13c-.85,3.74-2.12,9.84-3.08,13.69l-5.5,21.83h-4.68l10.47-40.44h6.35l3.2,23.19c.4,3.44.87,7.13.97,10.14h.18c1.23-3.01,2.96-6.63,4.71-10l12.52-23.33h6.51l-5.13,40.44h-4.84Z'
				className='shape'
			/>
			<path
				d='M4504.54,1642.09c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM4507.77,1616.79c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M4552.28,1599.49l-6.37,33.4c-.56,3.01-1.05,6.39-1.22,9.2h-4.56l.77-5.74h-.12c-2.65,4.11-6.3,6.4-10.47,6.4-5.6,0-8.67-4.6-8.67-10.56,0-10.32,7.67-19.77,17.95-19.77,1.82,0,3.87.39,5.12.99l2.6-13.92h4.95ZM4543.93,1617.62c-1-.68-2.66-1.23-4.75-1.23-6.96,0-12.38,7.42-12.38,15.12,0,3.51,1.2,7.16,5.48,7.16,3.82,0,8.46-4.37,9.71-10.9l1.94-10.15Z'
				className='shape'
			/>
			<path
				d='M4557.72,1642.09l5.54-29.02h4.96l-5.54,29.02h-4.97ZM4564.18,1604.97c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.45,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M4576.5,1637.05c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.26-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.7,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.43,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M4631.28,1624.48c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM4608.97,1630.64c0,4.72,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M4639.56,1642.09l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.97Z'
				className='shape'
			/>
			<polygon
				points='4706.15 1573.5 4706.56 1589.89 4723.8 1589.89 4706.81 1600.02 4707.21 1616.42 4696.31 1606.29 4679.32 1616.42 4689.57 1600.02 4678.66 1589.89 4695.9 1589.89 4706.15 1573.5'
				className='shape'
			/>
			<rect x='3805' y='1839' width='324.07' height='54.13' fill='none' className='shape' />
			<path
				d='M3814.46,1847.47c3.11-.54,6.51-.81,10.05-.81,6.74,0,11.89,1.91,14.88,5.38,2.18,2.26,3.78,5.86,3.8,10.96,0,7.32-2.91,14.57-8.11,19.01-4.68,3.93-10.57,5.63-18.33,5.63-3.53,0-7.19-.2-9.81-.51l7.53-39.66ZM3812.66,1883.23c1.81.24,3.72.28,5.22.28,6.43,0,11.1-1.89,14.47-5.37,3.64-3.71,5.51-9.23,5.51-14.92,0-7.16-3.5-12.51-13.58-12.51-1.81,0-4.07.11-5.51.42l-6.11,32.09Z'
				className='shape'
			/>
			<path
				d='M3871.91,1885.7c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM3866.4,1861.56c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M3883.2,1882.32c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.26-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.7,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.43,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M3959.9,1887.36l2.9-21.84c.53-3.86,1.42-9.78,2.19-13.68h-.19c-1.87,4.08-4.12,8.89-6.33,13.03l-12.01,22.24h-3.8l-2.99-21.78c-.62-4.64-1.03-9.34-1.3-13.48h-.13c-.85,3.74-2.12,9.84-3.08,13.69l-5.5,21.83h-4.68l10.47-40.44h6.35l3.2,23.19c.4,3.44.87,7.13.97,10.14h.18c1.23-3.01,2.96-6.63,4.71-10l12.52-23.33h6.51l-5.13,40.44h-4.84Z'
				className='shape'
			/>
			<path
				d='M4005.3,1869.76c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM3982.99,1875.91c0,4.72,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M4013.58,1887.36l5.54-29.02h4.96l-5.54,29.02h-4.97ZM4020.04,1850.25c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.46,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M4032.12,1887.36l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.97Z'
				className='shape'
			/>
			<path
				d='M4089.88,1885.7c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM4084.38,1861.56c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M4101.18,1882.32c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.26-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.7,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.43,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<polygon
				points='4164.5 1869.04 4164.9 1885.44 4182.14 1885.44 4165.15 1895.57 4165.56 1911.97 4154.65 1901.84 4137.67 1911.97 4147.91 1895.57 4137.01 1885.44 4154.25 1885.44 4164.5 1869.04'
				className='shape'
			/>
			<rect
				x='4007'
				y='1309.73'
				width='217.65'
				height='55.27'
				fill='none'
				className='shape'
			/>
			<path
				d='M4009.49,1352.41c2.2,1.48,5.23,2.58,8.61,2.58,4.55,0,8.74-2.72,8.74-7.59,0-3.01-1.69-5.24-5.92-7.56-5.16-2.79-8.05-6.03-8.05-10.37,0-7.24,6.22-11.87,13.65-11.87,3.95,0,6.89,1.15,8.28,2.1l-1.77,4.07c-1.27-.76-3.8-1.93-7.02-1.9-4.99,0-8.01,3.29-8.02,6.61,0,3.28,2.05,5.15,6.28,7.5,4.98,2.67,7.71,5.86,7.71,10.82,0,6.99-5.49,12.5-14.59,12.5-4.04,0-8.04-1.32-9.73-2.81l1.8-4.07Z'
				className='shape'
			/>
			<path
				d='M4054.45,1321.85l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.73.82,2.81,2.75,2.81.89,0,1.69-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.44l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
			<path
				d='M4064.47,1355.77c0-2.22,1.57-4.03,3.78-4.03,2.05,0,3.36,1.53,3.36,3.6,0,2.2-1.56,3.96-3.8,3.96-2.01,0-3.33-1.55-3.33-3.53Z'
				className='shape'
			/>
			<path
				d='M4105.86,1318.82c2.27-.53,5.5-.86,8.76-.86,3.9,0,7.65.94,9.91,3.11,1.91,1.77,2.93,4.13,2.93,7.32,0,4.51-2.21,8.31-4.84,10.52-3.12,2.63-7.7,3.87-12.25,3.87-1.52,0-2.84-.11-4.12-.32l-3.08,16.21h-4.89l7.59-39.84ZM4107.02,1338.26c1.41.3,2.56.4,4.03.4,6.82,0,11.4-4.24,11.4-9.93,0-4.83-3.44-6.73-8.05-6.73-1.97,0-3.46.17-4.36.43l-3.02,15.83Z'
				className='shape'
			/>
			<path
				d='M4151.3,1358.66c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM4154.53,1333.36c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M4196.48,1329.65l-3.91,20.57c-.61,3.23-1.02,6.04-1.3,8.45h-4.49l.75-5.48h-.12c-2.59,3.78-6.4,6.14-10.24,6.14s-7.66-1.8-7.66-8.4c0-1.4.18-2.96.56-4.88l3.14-16.39h4.96l-3.08,16.17c-.31,1.61-.49,3.01-.49,4.25,0,3,1.23,5.05,4.64,5.05,3.63,0,8.25-4.23,9.45-10.6l2.83-14.88h4.96Z'
				className='shape'
			/>
			<path d='M4204.55,1358.66l8.12-42.6h4.98l-8.13,42.6h-4.96Z' className='shape' />
			<polygon
				points='4231.52 1262.57 4231.92 1278.96 4249.16 1278.96 4232.17 1289.1 4232.58 1305.49 4221.67 1295.36 4204.69 1305.49 4214.93 1289.1 4204.03 1278.96 4221.27 1278.96 4231.52 1262.57'
				className='shape'
			/>
			<rect
				x='3103'
				y='1337.19'
				width='166.89'
				height='56.03'
				fill='none'
				className='shape'
			/>
			<path
				d='M3112.46,1346.67c2.27-.53,5.5-.86,8.76-.86,3.9,0,7.65.94,9.91,3.11,1.91,1.77,2.93,4.13,2.93,7.32,0,4.51-2.21,8.31-4.84,10.52-3.12,2.63-7.7,3.87-12.25,3.87-1.52,0-2.84-.11-4.12-.32l-3.08,16.21h-4.89l7.59-39.84ZM3113.62,1366.11c1.41.3,2.56.4,4.03.4,6.82,0,11.4-4.24,11.4-9.93,0-4.83-3.44-6.73-8.05-6.73-1.97,0-3.46.17-4.36.43l-3.02,15.83Z'
				className='shape'
			/>
			<path
				d='M3139.26,1386.51l5.54-29.02h4.97l-5.54,29.02h-4.96ZM3145.72,1349.39c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.45,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M3178.73,1384.85c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM3173.23,1360.71c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M3189.78,1386.51l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.97,5-6.96,8.89-6.96.46,0,1.03.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.96Z'
				className='shape'
			/>
			<path
				d='M3213.6,1386.51l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.97,5-6.96,8.89-6.96.46,0,1.03.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.96Z'
				className='shape'
			/>
			<path
				d='M3258.05,1384.85c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM3252.54,1360.71c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<polygon
				points='3305.32 1369.14 3305.73 1385.54 3322.97 1385.54 3305.98 1395.67 3306.39 1412.06 3295.48 1401.93 3278.49 1412.06 3288.74 1395.67 3277.83 1385.54 3295.07 1385.54 3305.32 1369.14'
				className='shape'
			/>
			<rect x='3522' y='1988' width='208.24' height='49.06' fill='none' className='shape' />
			<path
				d='M3531.56,1993.39h4.98l-6.89,36.11h16.31l-.83,4.33h-21.25l7.69-40.44Z'
				className='shape'
			/>
			<path
				d='M3555.02,2033.83l5.54-29.02h4.97l-5.54,29.02h-4.96ZM3561.48,1996.71c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.45,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M3573.56,2033.83l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.96l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.96Z'
				className='shape'
			/>
			<path
				d='M3630.36,2032.68c-1.48.73-4.49,1.78-8.43,1.78-7.46,0-11.16-5.06-11.16-11.22,0-9.9,7.37-19.07,17.8-19.07,2.7,0,5.15.79,6.03,1.32l-1.42,3.95c-1.15-.55-2.74-1.09-4.93-1.09-7.53,0-12.3,7.43-12.3,14.27,0,4.72,2.47,7.76,7.23,7.76,2.95,0,5.22-.91,6.7-1.62l.48,3.93Z'
				className='shape'
			/>
			<path
				d='M3667.88,2016.22c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM3645.57,2022.38c0,4.72,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.57-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path d='M3676.17,2033.83l8.12-42.6h4.98l-8.13,42.6h-4.97Z' className='shape' />
			<path
				d='M3694.7,2033.83l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.96l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.96Z'
				className='shape'
			/>
			<polygon
				points='3765.67 2012.97 3766.08 2029.37 3783.32 2029.37 3766.33 2039.5 3766.74 2055.9 3755.83 2045.76 3738.84 2055.9 3749.09 2039.5 3738.18 2029.37 3755.42 2029.37 3765.67 2012.97'
				className='shape'
			/>
			<rect
				x='3277.58'
				y='893.32'
				width='226.42'
				height='47.24'
				fill='none'
				className='shape'
			/>
			<path
				d='M3287.02,898.37c2.47-.5,5.39-.84,8.67-.84,4.17,0,7.18.84,9.33,2.77,1.86,1.52,2.9,3.67,2.9,6.3,0,5.11-4.12,8.9-8.71,10.09v.16c3.65,1.07,6.67,4.11,6.63,8.98,0,4.14-2.19,7.39-4.84,9.36-3.21,2.41-7.67,3.32-13.09,3.32-3.47,0-6.49-.21-8.38-.57l7.48-39.57ZM3285.11,934.22c1.26.2,2.73.26,4.09.26,5.89.03,11.42-2.43,11.42-8.9,0-4.75-4.01-6.83-8.54-6.83h-4.05l-2.92,15.47ZM3288.81,914.97h3.7c5.8,0,10.27-3.01,10.27-7.92,0-3.9-2.94-5.56-7.34-5.56-1.83,0-3.36.13-4.13.37l-2.5,13.11Z'
				className='shape'
			/>
			<path
				d='M3315.17,938.24l5.54-29.02h4.97l-5.54,29.02h-4.96ZM3321.63,901.13c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.45,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M3333.95,933.2c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.27-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.7,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.43,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M3360.88,938.24l3.85-20.57c.63-3.23,1.03-6.04,1.34-8.45h4.39l-.77,5.44h.14c2.72-4.05,6.37-6.1,10.22-6.1,4.42,0,6.57,2.8,6.78,6.47,2.6-4.2,6.29-6.41,10.66-6.47,3.36,0,7.05,2.14,7.05,7.61,0,1.34-.18,3.29-.48,4.93l-3.24,17.13h-4.86l3.13-16.71c.21-1.12.42-2.59.42-3.79,0-3.07-1.16-5.04-4.37-5.04-3.63,0-7.92,4.18-9.12,10.67l-2.77,14.87h-4.84l3.24-17.03c.24-1.3.39-2.41.39-3.54,0-2.44-.68-4.97-4.35-4.97s-8.15,4.8-9.27,10.96l-2.68,14.59h-4.86Z'
				className='shape'
			/>
			<path
				d='M3433.4,938.24c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM3436.63,912.94c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M3450.4,938.24l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.97,5-6.96,8.89-6.96.46,0,1.03.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.96Z'
				className='shape'
			/>
			<path
				d='M3474.23,938.24l8.1-42.6h4.95l-5.1,26.71h.12c.88-1.02,1.95-2.12,2.71-2.92l10.23-10.2h6.15l-12.66,11.91,8.66,17.1h-5.48l-6.99-14.32-3.67,3.28-2.08,11.05h-4.94Z'
				className='shape'
			/>
			<polygon
				points='3261.37 929.66 3261.78 946.06 3279.02 946.06 3262.03 956.19 3262.44 972.59 3251.53 962.46 3234.54 972.59 3244.79 956.19 3233.89 946.06 3251.13 946.06 3261.37 929.66'
				className='shape'
			/>
			<rect x='2377' y='2094' width='209.73' height='51.83' fill='none' className='shape' />
			<path
				d='M2386.46,2101.32c3.11-.54,6.51-.81,10.05-.81,6.74,0,11.89,1.91,14.88,5.38,2.18,2.26,3.78,5.86,3.8,10.96,0,7.32-2.91,14.57-8.11,19.01-4.68,3.93-10.57,5.63-18.33,5.63-3.53,0-7.19-.2-9.81-.51l7.53-39.66ZM2384.66,2137.08c1.81.24,3.72.28,5.22.28,6.43,0,11.1-1.89,14.47-5.37,3.64-3.71,5.51-9.23,5.51-14.92,0-7.16-3.5-12.51-13.58-12.51-1.81,0-4.07.11-5.51.42l-6.11,32.09Z'
				className='shape'
			/>
			<path
				d='M2443.91,2139.55c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM2438.4,2115.41c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M2454.96,2141.21l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.96l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.96Z'
				className='shape'
			/>
			<path
				d='M2497.9,2112.2l2.5,16.52c.44,3.3.81,5.54.93,7.13h.17c.64-1.54,1.41-3.45,3.09-6.76l8.86-16.89h5.45l-16.15,29.02h-4.9l-5.01-29.02h5.07Z'
				className='shape'
			/>
			<path
				d='M2543.99,2139.55c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM2538.48,2115.41c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M2555.04,2141.21l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.97,5-6.96,8.89-6.96.46,0,1.03.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.96Z'
				className='shape'
			/>
			<polygon
				points='2623.03 2136.03 2623.44 2152.42 2640.68 2152.42 2623.69 2162.55 2624.1 2178.95 2613.19 2168.82 2596.2 2178.95 2606.45 2162.55 2595.55 2152.42 2612.79 2152.42 2623.03 2136.03'
				className='shape'
			/>
			<rect x='2369' y='1863' width='274.87' height='46.61' fill='none' className='shape' />
			<path
				d='M2398.82,1906.3c-2.28,1.02-5.95,1.94-10.49,1.94-10.18,0-16.41-6.47-16.41-16.79,0-7.61,3.08-14.87,8.63-19.49,4.18-3.53,9.33-5.42,15.24-5.42,4.5,0,7.73,1.12,8.76,1.94l-1.6,4.01c-1.5-.91-4.35-1.66-7.95-1.66-4.23,0-8.47,1.64-11.58,4.53-3.8,3.56-6.2,9.26-6.2,15.39,0,7.23,3.32,13.2,12.3,13.2,3.05,0,6.39-.61,8.64-1.73l.66,4.07Z'
				className='shape'
			/>
			<path
				d='M2408.8,1907.6l8.1-42.6h4.98l-3.62,18.7h.12c2.49-3.53,5.99-5.77,10.37-5.77,3.29,0,7.22,1.99,7.22,7.77,0,1.55-.19,3.44-.48,4.91l-3.23,16.99h-4.96l3.18-16.77c.2-1.06.39-2.4.39-4,0-2.67-1.28-4.76-4.51-4.76-3.85,0-8.67,4.5-9.88,11l-2.71,14.54h-4.96Z'
				className='shape'
			/>
			<path
				d='M2466.57,1905.94c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM2461.07,1881.8c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M2484.13,1878.59l2.87,15.61c.64,3.34,1.02,5.48,1.31,7.65h.15c.76-1.86,1.62-3.89,3.08-7.11l7.43-16.15h5.28l-10.9,22.05c-3.11,6.29-6.05,11.38-10,15.27-3.24,3.27-6.79,4.65-8.44,5.01l-1.22-4.28c1.25-.44,3.35-1.25,5.32-2.79,1.96-1.51,4.06-3.85,5.61-6.7.25-.48.23-.81.15-1.32l-5.82-27.25h5.17Z'
				className='shape'
			/>
			<path
				d='M2529.51,1905.94c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM2524,1881.8c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M2540.56,1907.6l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.96l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.96Z'
				className='shape'
			/>
			<path
				d='M2577.4,1907.6l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.96l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.96Z'
				className='shape'
			/>
			<path
				d='M2635.17,1905.94c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM2629.66,1881.8c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<polygon
				points='2681.99 1896.51 2682.4 1912.91 2699.64 1912.91 2682.65 1923.04 2683.05 1939.44 2672.15 1929.3 2655.16 1939.44 2665.41 1923.04 2654.5 1912.91 2671.74 1912.91 2681.99 1896.51'
				className='shape'
			/>
			<rect
				x='1890.32'
				y='859.26'
				width='201.68'
				height='52.74'
				fill='none'
				className='shape'
			/>
			<path
				d='M1904.87,866.49l-3.27,17.06h18.6l3.26-17.06h4.99l-7.7,40.44h-4.98l3.59-19h-18.61l-3.59,19h-4.96l7.69-40.44h4.98Z'
				className='shape'
			/>
			<path
				d='M1955.37,905.27c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM1949.87,881.13c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path d='M1966.44,906.93l8.12-42.6h4.98l-8.13,42.6h-4.97Z' className='shape' />
			<path
				d='M2005.89,905.27c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM2000.39,881.13c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M2016.94,906.93l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.96l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.96Z'
				className='shape'
			/>
			<path
				d='M2073.02,906.93c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM2076.25,881.63c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<polygon
				points='1869.72 835.18 1870.13 851.57 1887.37 851.57 1870.38 861.71 1870.78 878.1 1859.88 867.97 1842.89 878.1 1853.14 861.71 1842.23 851.57 1859.47 851.57 1869.72 835.18'
				className='shape'
			/>
			<rect
				x='1256.38'
				y='1268.75'
				width='324.11'
				height='83.5'
				fill='none'
				className='shape'
			/>
			<path
				d='M1265.81,1291.93c2.47-.5,5.39-.84,8.67-.84,4.17,0,7.18.84,9.33,2.77,1.86,1.52,2.9,3.67,2.9,6.3,0,5.11-4.12,8.9-8.71,10.09v.16c3.65,1.07,6.67,4.11,6.63,8.98,0,4.14-2.19,7.39-4.84,9.36-3.21,2.41-7.67,3.32-13.09,3.32-3.47,0-6.49-.21-8.38-.57l7.48-39.57ZM1263.9,1327.78c1.26.2,2.73.26,4.09.26,5.89.03,11.42-2.43,11.42-8.9,0-4.75-4.01-6.83-8.54-6.83h-4.05l-2.92,15.47ZM1267.61,1308.53h3.7c5.8,0,10.27-3.01,10.27-7.92,0-3.9-2.94-5.56-7.34-5.56-1.83,0-3.36.13-4.13.37l-2.5,13.11Z'
				className='shape'
			/>
			<path
				d='M1322.05,1314.19c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM1299.73,1320.35c0,4.72,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.57-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M1330.32,1331.8l5.54-29.02h4.96l-5.54,29.02h-4.96ZM1336.78,1294.68c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.45,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M1349.1,1326.76c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.27-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.7,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.43,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M1396.97,1330.14c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM1391.46,1306c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<polygon
				points='1252.26 1253.78 1252.66 1270.17 1269.9 1270.17 1252.91 1280.31 1253.32 1296.7 1242.41 1286.57 1225.43 1296.7 1235.67 1280.31 1224.77 1270.17 1242.01 1270.17 1252.26 1253.78'
				className='shape'
			/>
			<rect
				x='1317'
				y='1808.53'
				width='385.29'
				height='48.47'
				fill='none'
				className='shape'
			/>
			<path
				d='M1319.49,1847.81c2.2,1.48,5.23,2.58,8.61,2.58,4.55,0,8.74-2.72,8.74-7.59,0-3.01-1.7-5.24-5.92-7.56-5.16-2.79-8.05-6.03-8.05-10.37,0-7.24,6.22-11.87,13.65-11.87,3.95,0,6.89,1.15,8.28,2.1l-1.77,4.07c-1.27-.76-3.8-1.93-7.02-1.9-4.99,0-8.01,3.29-8.02,6.61,0,3.28,2.05,5.15,6.28,7.5,4.98,2.67,7.71,5.86,7.71,10.82,0,6.99-5.49,12.5-14.59,12.5-4.04,0-8.04-1.32-9.73-2.81l1.8-4.07Z'
				className='shape'
			/>
			<path
				d='M1371.24,1854.07c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM1374.47,1828.76c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path d='M1388.13,1854.07l8.12-42.6h4.98l-8.13,42.6h-4.96Z' className='shape' />
			<path
				d='M1419.65,1817.25l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.73.82,2.81,2.75,2.81.89,0,1.69-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.44l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
			<path
				d='M1453.82,1813.63h4.98l-6.89,36.11h16.31l-.83,4.33h-21.25l7.69-40.44Z'
				className='shape'
			/>
			<path
				d='M1496.34,1854.07c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM1499.57,1828.76c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M1513.23,1854.07l8.1-42.6h4.95l-5.1,26.71h.12c.88-1.02,1.95-2.12,2.71-2.92l10.23-10.2h6.15l-12.66,11.91,8.66,17.1h-5.48l-6.99-14.32-3.67,3.28-2.08,11.05h-4.94Z'
				className='shape'
			/>
			<path
				d='M1565.46,1852.4c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM1559.96,1828.26c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M1620.36,1852.76c-2.28,1.02-5.95,1.94-10.49,1.94-10.18,0-16.41-6.47-16.41-16.79,0-7.61,3.08-14.87,8.63-19.49,4.18-3.53,9.33-5.42,15.24-5.42,4.5,0,7.73,1.12,8.76,1.94l-1.6,4.01c-1.5-.91-4.35-1.66-7.95-1.66-4.23,0-8.47,1.64-11.58,4.53-3.8,3.56-6.2,9.26-6.2,15.39,0,7.23,3.32,13.2,12.3,13.2,3.05,0,6.39-.61,8.64-1.73l.66,4.07Z'
				className='shape'
			/>
			<path
				d='M1630.28,1854.07l5.54-29.02h4.96l-5.54,29.02h-4.96ZM1636.74,1816.95c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.45,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M1661.8,1817.25l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.73.82,2.81,2.75,2.81.89,0,1.69-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.44l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
			<path
				d='M1679.39,1825.05l2.87,15.61c.64,3.34,1.02,5.48,1.31,7.65h.15c.76-1.86,1.62-3.89,3.08-7.11l7.43-16.15h5.28l-10.9,22.05c-3.11,6.29-6.05,11.38-10,15.27-3.24,3.27-6.79,4.65-8.44,5.01l-1.22-4.28c1.25-.44,3.35-1.25,5.32-2.79,1.96-1.51,4.06-3.85,5.61-6.7.26-.48.23-.81.15-1.32l-5.82-27.25h5.17Z'
				className='shape'
			/>
			<polygon
				points='1736.78 1845.97 1737.18 1862.37 1754.42 1862.37 1737.44 1872.5 1737.84 1888.9 1726.94 1878.76 1709.95 1888.9 1720.2 1872.5 1709.29 1862.37 1726.53 1862.37 1736.78 1845.97'
				className='shape'
			/>
			<rect
				x='647.71'
				y='1894.23'
				width='597.53'
				height='83.5'
				fill='none'
				className='shape'
			/>
			<path
				d='M677.53,1955.97c-2.28,1.02-5.95,1.94-10.49,1.94-10.18,0-16.41-6.47-16.41-16.79,0-7.61,3.08-14.87,8.63-19.49,4.18-3.53,9.33-5.42,15.24-5.42,4.5,0,7.73,1.12,8.76,1.94l-1.6,4.01c-1.5-.91-4.35-1.66-7.95-1.66-4.23,0-8.47,1.64-11.58,4.53-3.8,3.56-6.2,9.26-6.2,15.39,0,7.23,3.32,13.2,12.3,13.2,3.05,0,6.39-.61,8.64-1.73l.66,4.07Z'
				className='shape'
			/>
			<path
				d='M706.27,1957.28c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM709.5,1931.98c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M723.27,1957.28l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.97,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.96Z'
				className='shape'
			/>
			<path
				d='M747.39,1952.24c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.26-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.7,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.43,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M802.17,1939.67c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM779.86,1945.83c0,4.72,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.57-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M810.45,1957.28l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.96l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.96Z'
				className='shape'
			/>
			<path
				d='M891.13,1955.97c-2.28,1.02-5.95,1.94-10.49,1.94-10.18,0-16.41-6.47-16.41-16.79,0-7.61,3.08-14.87,8.63-19.49,4.18-3.53,9.33-5.42,15.24-5.42,4.5,0,7.73,1.12,8.76,1.94l-1.6,4.01c-1.5-.91-4.35-1.66-7.95-1.66-4.23,0-8.47,1.64-11.58,4.53-3.8,3.56-6.2,9.26-6.2,15.39,0,7.23,3.32,13.2,12.3,13.2,3.05,0,6.39-.61,8.64-1.73l.66,4.07Z'
				className='shape'
			/>
			<path
				d='M901.05,1957.28l5.54-29.02h4.96l-5.54,29.02h-4.96ZM907.51,1920.16c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.45,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M932.57,1920.47l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.73.82,2.81,2.75,2.81.89,0,1.69-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.44l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
			<path
				d='M950.16,1928.26l2.87,15.61c.64,3.34,1.02,5.48,1.31,7.65h.15c.76-1.86,1.62-3.89,3.08-7.11l7.43-16.15h5.28l-10.9,22.05c-3.11,6.29-6.05,11.38-10,15.27-3.24,3.27-6.79,4.65-8.44,5.01l-1.22-4.28c1.25-.44,3.35-1.25,5.32-2.79,1.96-1.51,4.06-3.85,5.61-6.7.26-.48.23-.81.15-1.32l-5.82-27.25h5.17Z'
				className='shape'
			/>
			<polygon
				points='643.58 1878.93 643.99 1895.33 661.23 1895.33 644.24 1905.46 644.65 1921.86 633.74 1911.72 616.75 1921.86 627 1905.46 616.09 1895.33 633.33 1895.33 643.58 1878.93'
				className='shape'
			/>
			<rect
				x='100.65'
				y='1962.47'
				width='343.35'
				height='50.54'
				fill='none'
				className='shape'
			/>
			<path
				d='M103.14,2002.79c2.2,1.48,5.23,2.58,8.61,2.58,4.55,0,8.74-2.72,8.74-7.59,0-3.01-1.7-5.24-5.92-7.56-5.16-2.79-8.05-6.03-8.05-10.37,0-7.24,6.22-11.87,13.65-11.87,3.95,0,6.89,1.15,8.28,2.1l-1.77,4.07c-1.27-.76-3.8-1.93-7.02-1.9-4.99,0-8.01,3.29-8.02,6.61,0,3.28,2.05,5.15,6.28,7.5,4.98,2.67,7.71,5.86,7.71,10.82,0,6.99-5.49,12.5-14.59,12.5-4.04,0-8.04-1.32-9.73-2.81l1.8-4.07Z'
				className='shape'
			/>
			<path
				d='M154.89,2009.04c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM158.12,1983.74c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M191.73,2007.89c-1.48.73-4.49,1.78-8.43,1.78-7.46,0-11.16-5.06-11.16-11.22,0-9.9,7.37-19.07,17.8-19.07,2.7,0,5.15.79,6.03,1.32l-1.42,3.95c-1.15-.55-2.74-1.09-4.93-1.09-7.53,0-12.3,7.43-12.3,14.27,0,4.72,2.47,7.76,7.23,7.76,2.95,0,5.22-.91,6.7-1.62l.48,3.93Z'
				className='shape'
			/>
			<path
				d='M202.01,2009.04l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.97,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.96Z'
				className='shape'
			/>
			<path
				d='M244.23,2009.04c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM247.46,1983.74c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M261.23,2009.04l3.85-20.57c.63-3.23,1.03-6.04,1.34-8.45h4.39l-.77,5.44h.14c2.72-4.05,6.37-6.1,10.22-6.1,4.42,0,6.57,2.8,6.78,6.47,2.6-4.2,6.29-6.41,10.66-6.47,3.36,0,7.05,2.14,7.05,7.61,0,1.34-.18,3.29-.48,4.93l-3.24,17.13h-4.86l3.13-16.71c.21-1.12.42-2.59.42-3.79,0-3.07-1.16-5.04-4.37-5.04-3.63,0-7.92,4.18-9.12,10.67l-2.77,14.87h-4.84l3.24-17.03c.24-1.3.39-2.41.39-3.54,0-2.44-.68-4.97-4.35-4.97s-8.15,4.8-9.27,10.96l-2.68,14.59h-4.86Z'
				className='shape'
			/>
			<path
				d='M335.43,2007.38c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM329.93,1983.24c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M346.49,2009.04l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.96l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.96Z'
				className='shape'
			/>
			<path
				d='M396.31,1972.23l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.73.82,2.81,2.75,2.81.89,0,1.69-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.44l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
			<path
				d='M434.51,1991.43c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM412.2,1997.59c0,4.72,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.57-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<polygon
				points='386.49 1911.89 386.89 1928.29 404.13 1928.29 387.15 1938.42 387.55 1954.82 376.65 1944.68 359.66 1954.82 369.91 1938.42 359 1928.29 376.24 1928.29 386.49 1911.89'
				className='shape'
			/>
			<rect
				x='486.28'
				y='817.51'
				width='324.11'
				height='83.5'
				fill='none'
				className='shape'
			/>
			<path
				d='M488.78,874.31c2.2,1.48,5.23,2.58,8.61,2.58,4.55,0,8.74-2.72,8.74-7.59,0-3.01-1.7-5.24-5.91-7.56-5.16-2.79-8.05-6.03-8.05-10.37,0-7.24,6.22-11.87,13.65-11.87,3.95,0,6.89,1.15,8.28,2.1l-1.77,4.07c-1.27-.76-3.8-1.93-7.02-1.9-4.99,0-8.01,3.29-8.02,6.61,0,3.28,2.05,5.15,6.28,7.5,4.98,2.67,7.71,5.86,7.71,10.82,0,6.99-5.49,12.5-14.59,12.5-4.04,0-8.04-1.32-9.73-2.81l1.8-4.07Z'
				className='shape'
			/>
			<path
				d='M540.53,880.56c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM543.75,855.26c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path d='M557.42,880.56l8.12-42.6h4.98l-8.13,42.6h-4.96Z' className='shape' />
			<path
				d='M596.87,878.9c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM591.37,854.76c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M607.92,880.56l3.85-20.57c.63-3.23,1.03-6.04,1.34-8.45h4.39l-.77,5.44h.14c2.72-4.05,6.37-6.1,10.22-6.1,4.42,0,6.57,2.8,6.78,6.47,2.6-4.2,6.29-6.41,10.66-6.47,3.36,0,7.05,2.14,7.05,7.61,0,1.34-.18,3.29-.48,4.93l-3.24,17.13h-4.86l3.13-16.71c.21-1.12.42-2.59.42-3.79,0-3.07-1.16-5.04-4.37-5.04-3.63,0-7.92,4.18-9.12,10.67l-2.77,14.87h-4.84l3.24-17.03c.24-1.3.39-2.41.39-3.54,0-2.44-.68-4.97-4.35-4.97s-8.15,4.8-9.27,10.96l-2.68,14.59h-4.86Z'
				className='shape'
			/>
			<polygon
				points='472.19 812.1 472.59 828.5 489.83 828.5 472.84 838.63 473.25 855.03 462.34 844.9 445.36 855.03 455.6 838.63 444.7 828.5 461.94 828.5 472.19 812.1'
				className='shape'
			/>
			<rect
				x='645.48'
				y='471.55'
				width='445.22'
				height='83.5'
				fill='none'
				className='shape'
			/>
			<path
				d='M684.93,510.08c0,7.01-2.57,14.74-7.37,19.53-3.58,3.54-8.28,5.64-13.86,5.64-10.45,0-15.33-7.87-15.33-16.46,0-7.11,2.79-15,7.71-19.82,3.47-3.38,8.46-5.48,13.56-5.48,10.88,0,15.29,7.92,15.29,16.58ZM659.74,501.75c-3.89,3.9-6.14,11.01-6.14,16.66,0,6.57,2.92,12.64,10.83,12.64,3.45,0,6.72-1.49,9.24-4.04,3.82-3.83,6.02-11.09,6.02-16.72s-1.88-12.59-10.71-12.59c-3.59,0-6.76,1.57-9.24,4.05Z'
				className='shape'
			/>
			<path d='M692.44,534.6l8.12-42.6h4.98l-8.13,42.6h-4.96Z' className='shape' />
			<path
				d='M717.36,505.58l2.87,15.61c.64,3.34,1.02,5.48,1.31,7.65h.15c.76-1.86,1.62-3.9,3.08-7.11l7.43-16.15h5.28l-10.9,22.05c-3.11,6.29-6.05,11.38-10,15.27-3.24,3.27-6.79,4.65-8.44,5.01l-1.22-4.28c1.25-.44,3.35-1.25,5.32-2.79,1.96-1.51,4.06-3.85,5.61-6.7.26-.48.23-.81.15-1.32l-5.82-27.25h5.17Z'
				className='shape'
			/>
			<path
				d='M742.28,534.6l3.85-20.57c.63-3.23,1.03-6.04,1.34-8.45h4.39l-.77,5.44h.14c2.72-4.05,6.37-6.1,10.22-6.1,4.42,0,6.57,2.8,6.78,6.47,2.6-4.2,6.29-6.41,10.66-6.47,3.36,0,7.05,2.14,7.05,7.61,0,1.34-.18,3.29-.48,4.93l-3.24,17.13h-4.86l3.13-16.71c.21-1.12.42-2.59.42-3.79,0-3.07-1.16-5.04-4.37-5.04-3.63,0-7.92,4.18-9.12,10.67l-2.77,14.87h-4.84l3.24-17.03c.24-1.3.39-2.41.39-3.54,0-2.44-.68-4.97-4.35-4.97s-8.15,4.8-9.27,10.96l-2.68,14.59h-4.86Z'
				className='shape'
			/>
			<path
				d='M792.94,546.48l5.81-30.61c.66-3.49,1.25-7.36,1.64-10.28h4.55l-.81,5.46h.12c2.64-3.83,6.46-6.12,10.44-6.12,6.29,0,8.94,5.16,8.94,10.48,0,10.22-7.33,19.85-17,19.85-3.08,0-5.13-.68-6.25-1.3h-.12l-2.34,12.52h-4.96ZM801.11,529.73c1.28,1,3.16,1.6,5.54,1.6,6.42,0,11.79-7.97,11.79-15.56,0-3.04-1.34-6.71-5.56-6.71-3.92,0-8.78,4.46-10.29,12.57l-1.47,8.1Z'
				className='shape'
			/>
			<path
				d='M831.86,534.6l5.54-29.02h4.96l-5.54,29.02h-4.96ZM838.32,497.48c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.45,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M869.64,534.6c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM872.87,509.3c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<polygon
				points='635.48 449.54 635.89 465.93 653.13 465.93 636.14 476.07 636.54 492.46 625.64 482.33 608.65 492.46 618.9 476.07 607.99 465.93 625.23 465.93 635.48 449.54'
				className='shape'
			/>
			<rect
				x='1500.42'
				y='3152.23'
				width='227.58'
				height='49.77'
				fill='none'
				className='shape'
			/>
			<path
				d='M1509.88,3158.57c2.27-.53,5.5-.86,8.76-.86,3.9,0,7.65.94,9.91,3.11,1.91,1.77,2.93,4.13,2.93,7.32,0,4.51-2.21,8.31-4.84,10.52-3.12,2.63-7.7,3.87-12.25,3.87-1.52,0-2.84-.11-4.12-.32l-3.08,16.21h-4.89l7.59-39.84ZM1511.04,3178.01c1.41.3,2.56.4,4.03.4,6.82,0,11.4-4.24,11.4-9.93,0-4.83-3.44-6.73-8.05-6.73-1.97,0-3.46.17-4.36.43l-3.02,15.83Z'
				className='shape'
			/>
			<path
				d='M1537.04,3198.41l8.1-42.6h4.98l-3.62,18.7h.12c2.49-3.53,5.99-5.77,10.37-5.77,3.29,0,7.22,1.99,7.22,7.77,0,1.55-.19,3.44-.48,4.91l-3.23,16.99h-4.96l3.18-16.77c.2-1.06.39-2.4.39-4,0-2.67-1.28-4.76-4.51-4.76-3.85,0-8.67,4.5-9.88,11l-2.71,14.54h-4.96Z'
				className='shape'
			/>
			<path
				d='M1601.73,3180.81c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM1579.41,3186.96c0,4.72,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.57-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M1631.11,3196.75c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM1625.61,3172.61c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M1642.16,3198.41l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.96l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.96Z'
				className='shape'
			/>
			<path
				d='M1679,3198.41l5.54-29.02h4.96l-5.54,29.02h-4.96ZM1685.46,3161.3c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.45,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M1705,3169.4l2.83,6.32c.82,1.87,1.36,3.3,1.94,4.65h.17c1.11-1.6,1.76-2.62,3.17-4.39l5.36-6.57h5.74l-12.24,14.13,6.86,14.89h-5.42l-2.92-6.56c-.99-2.16-1.41-3.27-2.1-5.16h-.16c-.85,1.39-1.72,2.74-2.98,4.44l-5.88,7.29h-5.77l12.74-14.94-6.74-14.07h5.4Z'
				className='shape'
			/>
			<polygon
				points='1490.8 3108.37 1491.21 3124.76 1508.45 3124.76 1491.46 3134.89 1491.87 3151.29 1480.96 3141.16 1463.97 3151.29 1474.22 3134.89 1463.32 3124.76 1480.56 3124.76 1490.8 3108.37'
				className='shape'
			/>
			<rect x='2443.1' y='2824' width='247.9' height='50.26' fill='none' className='shape' />
			<path
				d='M2445.59,2864.18c2.2,1.48,5.23,2.58,8.61,2.58,4.55,0,8.74-2.72,8.74-7.59,0-3.01-1.7-5.24-5.92-7.56-5.16-2.79-8.05-6.03-8.05-10.37,0-7.24,6.22-11.87,13.65-11.87,3.95,0,6.89,1.15,8.28,2.1l-1.77,4.07c-1.27-.76-3.8-1.93-7.02-1.9-4.99,0-8.01,3.29-8.02,6.61,0,3.28,2.05,5.15,6.28,7.5,4.98,2.67,7.71,5.86,7.71,10.82,0,6.99-5.49,12.5-14.59,12.5-4.04,0-8.04-1.32-9.73-2.81l1.8-4.07Z'
				className='shape'
			/>
			<path
				d='M2497.34,2870.43c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM2500.57,2845.13c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M2514.34,2870.43l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.96l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.96Z'
				className='shape'
			/>
			<path
				d='M2564.17,2833.62l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.73.82,2.81,2.75,2.81.89,0,1.69-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.44l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
			<path
				d='M2593.94,2870.43c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM2597.17,2845.13c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M2634.4,2829.99h20.53l-.83,4.25h-15.52l-2.61,13.64h14.3l-.83,4.23h-14.3l-3.46,18.32h-4.97l7.69-40.44Z'
				className='shape'
			/>
			<path
				d='M2678.42,2868.77c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM2672.92,2844.63c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<polygon
				points='2434.58 2872.15 2434.99 2888.54 2452.22 2888.54 2435.24 2898.68 2435.64 2915.07 2424.74 2904.94 2407.75 2915.07 2418 2898.68 2407.09 2888.54 2424.33 2888.54 2434.58 2872.15'
				className='shape'
			/>
			<rect
				x='2362.96'
				y='3065.43'
				width='975.28'
				height='222.77'
				fill='none'
				className='shape'
			/>
			<path
				d='M2369.81,3218.15c6.04,4.07,14.36,7.09,23.64,7.09,12.5.02,24.01-7.46,24.01-20.86,0-8.26-4.66-14.4-16.25-20.77-14.18-7.67-22.11-16.56-22.11-28.49,0-19.88,17.08-32.61,37.5-32.61,10.85,0,18.93,3.15,22.75,5.78l-4.85,11.17c-3.49-2.1-10.43-5.29-19.27-5.22-13.72,0-22,9.04-22.03,18.16,0,9.01,5.63,14.14,17.25,20.59,13.69,7.33,21.19,16.09,21.19,29.73,0,19.21-15.08,34.34-40.08,34.34-11.11,0-22.08-3.63-26.72-7.72l4.95-11.19Z'
				className='shape'
			/>
			<path
				d='M2535.75,3186.95c0,24.62-17.48,50.18-44.28,50.18-19.96,0-31.12-14.8-31.12-32.73,0-26.33,18.28-50.6,44.21-50.6,21.5,0,31.2,16.26,31.2,33.15ZM2474.45,3203.87c0,12.95,7.2,22.44,18.89,22.44,16.08,0,28.29-20.85,28.29-39.38,0-9.31-4.3-22.29-18.58-22.29-17.23,0-28.62,20.96-28.61,39.23Z'
				className='shape'
			/>
			<path
				d='M2636.22,3155.62l-10.74,56.51c-1.68,8.86-2.8,16.59-3.56,23.2h-12.33l2.07-15.04-.33-.02c-7.11,10.4-17.59,16.88-28.12,16.88s-21.05-4.94-21.05-23.08c0-3.83.49-8.14,1.53-13.42l8.62-45.02h13.64l-8.47,44.43c-.85,4.43-1.36,8.26-1.36,11.69,0,8.24,3.38,13.87,12.74,13.87,9.96,0,22.66-11.62,25.97-29.12l7.77-40.87h13.64Z'
				className='shape'
			/>
			<path
				d='M2694.02,3134.2l-4.1,21.42h19.05l-2.13,10.7h-19.06l-7.34,38.75c-.86,4.45-1.58,8.57-1.58,12.72,0,4.77,2.26,7.73,7.54,7.73,2.46,0,4.66-.17,6.44-.64l-.66,10.75c-2.43.93-6.59,1.45-10.57,1.45-12.05,0-16.78-7.31-16.78-15.46,0-4.64.58-9.19,1.75-14.96l7.78-40.34h-11.4l2.07-10.7h11.44l3.36-17.96,14.19-3.46Z'
				className='shape'
			/>
			<path
				d='M2723.11,3235.32l22.24-117.02h13.67l-9.96,51.36h.33c6.84-9.69,16.45-15.86,28.48-15.86,9.05,0,19.84,5.47,19.84,21.35,0,4.26-.53,9.44-1.32,13.49l-8.87,46.68h-13.64l8.75-46.05c.56-2.91,1.08-6.59,1.08-11,0-7.33-3.52-13.09-12.38-13.09-10.58,0-23.82,12.37-27.15,30.21l-7.43,39.93h-13.64Z'
				className='shape'
			/>
			<path
				d='M2842.18,3155.62l2.81,44.82c.61,9.85.56,14.96.38,21.44h.37c1.91-5.2,4.79-12.04,8.75-20.01l23.72-46.26h11.9l5.04,45.41c.81,8.77,1.35,15.56,1.26,20.85h.4c2.12-6.42,4.3-12.59,7.53-20.22l21.52-46.04h13.92l-39.39,79.7h-12.69l-5.26-43.3c-.79-7.39-1.22-14.18-1.16-21.22h-.34c-3.34,7.68-5.63,13.74-9.25,20.81l-22.86,43.71h-12.78l-7.35-79.7h13.49Z'
				className='shape'
			/>
			<path
				d='M3009.17,3230.75c-6.03,3.39-15.66,6.3-26.35,6.3-21.18,0-30.32-14.43-30.32-32.07,0-24,17.83-51.18,43.49-51.18,15.16,0,23.39,9.04,23.41,20.45,0,20.93-23.59,26.45-53.05,25.89-.67,3.46-.2,10.89,1.61,15.17,3.21,7.18,9.53,10.71,17.73,10.71,9.48,0,16.59-2.82,21.47-5.46l2.01,10.19ZM2994.05,3164.44c-13.02,0-22.85,12.71-26.18,25.19,21.48.25,38.3-2.61,38.3-15.03,0-6.56-5-10.15-12.12-10.15Z'
				className='shape'
			/>
			<path
				d='M3040.19,3221.48c3.76,2.25,10.58,4.97,17.14,4.96,9.2-.01,15.17-5.95,15.17-13.01,0-6.22-2.8-10.12-11.07-14.7-9.23-5.1-14.41-12.15-14.41-20.32,0-13.92,12.08-24.59,28.89-24.59,7.23,0,13.61,1.94,16.59,3.96l-3.83,10.32c-2.75-1.59-7.79-3.63-13.74-3.63-8.34,0-14.22,5.19-14.22,11.97,0,5.87,3.83,9.41,10.95,13.42,8.88,5.02,14.88,11.98,14.88,20.94,0,16.75-13.62,26.27-30.44,26.27-8.57,0-16.21-2.7-19.83-5.46l3.91-10.11Z'
				className='shape'
			/>
			<path
				d='M3149.86,3134.2l-4.1,21.42h19.05l-2.13,10.7h-19.06l-7.34,38.75c-.86,4.45-1.58,8.57-1.58,12.72,0,4.77,2.26,7.73,7.54,7.73,2.46,0,4.66-.17,6.44-.64l-.66,10.75c-2.43.93-6.59,1.45-10.57,1.45-12.05,0-16.78-7.31-16.78-15.46,0-4.64.58-9.19,1.75-14.96l7.78-40.34h-11.4l2.07-10.7h11.44l3.36-17.96,14.19-3.46Z'
				className='shape'
			/>
			<rect
				x='286.08'
				y='1090.89'
				width='548.91'
				height='222.77'
				fill='none'
				className='shape'
			/>
			<path
				d='M312.06,1151.33c6.24-1.45,15.11-2.37,24.07-2.37,10.72,0,21.03,2.58,27.22,8.56,5.24,4.86,8.06,11.35,8.06,20.1,0,12.4-6.08,22.84-13.3,28.9-8.58,7.23-21.16,10.62-33.66,10.62-4.17,0-7.81-.29-11.32-.88l-8.47,44.52h-13.44l20.85-109.45ZM315.25,1204.73c3.88.83,7.03,1.09,11.07,1.09,18.74,0,31.32-11.65,31.32-27.28,0-13.26-9.44-18.49-22.12-18.49-5.42,0-9.51.48-11.97,1.18l-8.31,43.5Z'
				className='shape'
			/>
			<path
				d='M436.88,1260.78c-.06-4.8.75-12.34,1.78-20.59h-.35c-8.61,16.55-19.61,22.41-30.86,22.41-14.12,0-22.92-11.22-22.92-26.34,0-27.77,20.43-56.99,55.1-56.99,7.64,0,15.98,1.31,21.51,3.02l-8.13,41.55c-2.64,13.87-3.74,28.12-3.37,36.95h-12.75ZM445.75,1191.27c-1.92-.62-4.87-1.13-9.48-1.13-20.64,0-37.48,21.47-37.57,43.65-.06,8.91,3.08,17.59,13.61,17.59,11.44,0,24.84-14.86,28.81-36.05l4.63-24.05Z'
				className='shape'
			/>
			<path
				d='M538.07,1257.62c-4.08,2.02-12.33,4.89-23.16,4.89-20.51,0-30.66-13.9-30.66-30.83,0-27.2,20.24-52.39,48.89-52.39,7.43,0,14.14,2.17,16.56,3.62l-3.91,10.84c-3.17-1.51-7.54-3.01-13.54-3.01-20.69,0-33.79,20.41-33.79,39.2,0,12.96,6.78,21.32,19.85,21.32,8.1,0,14.34-2.49,18.42-4.44l1.32,10.8Z'
				className='shape'
			/>
			<path
				d='M566.3,1260.78l15.22-79.7h13.64l-15.22,79.7h-13.64ZM584.05,1158.82c.06-5.27,4.05-9.25,8.99-9.25s8.14,3.59,8.14,8.58c-.17,5.39-4,9.2-9.27,9.2-4.82,0-7.95-3.68-7.86-8.53Z'
				className='shape'
			/>
			<path
				d='M619.29,1260.78l13.06-68.97h-10.63l2.07-10.73h10.66l.74-4.11c3.96-21.78,17.36-35.02,38.13-35.02,7.46,0,15.23,2.14,18.09,4.23l-4.27,10.8c-3.38-1.78-9.1-3.62-15.8-3.62-14.28,0-20.57,10.98-22.77,23.93l-.64,3.78h42.79l-15.2,79.7h-13.64l13.06-68.97h-29.07l-13.06,68.97h-13.51Z'
				className='shape'
			/>
			<path
				d='M767.47,1257.62c-4.08,2.02-12.33,4.89-23.16,4.89-20.51,0-30.66-13.9-30.66-30.83,0-27.2,20.24-52.39,48.89-52.39,7.43,0,14.14,2.17,16.56,3.62l-3.91,10.84c-3.17-1.51-7.54-3.01-13.54-3.01-20.69,0-33.79,20.41-33.79,39.2,0,12.96,6.78,21.32,19.85,21.32,8.1,0,14.34-2.49,18.42-4.44l1.32,10.8Z'
				className='shape'
			/>
			<rect
				x='1215.82'
				y='1460.04'
				width='1348.94'
				height='222.77'
				fill='none'
				className='shape'
			/>
			<path
				d='M1241.82,1520.49c6.78-1.53,15.97-2.37,24.23-2.37,11.09,0,20.6,2.61,26.53,8.05,5.14,4.45,8.2,10.83,8.2,18.39,0,16.11-12.37,28.18-26.38,32.1l-.04.42c7.77,2.59,11.43,10.91,12.25,22.3,1.24,15.49,2.02,26.11,3.47,30.56h-14.15c-.64-2.35-1.78-13.98-2.57-26.79-.87-15.3-6.48-21.6-17.51-21.6h-12.14l-9.18,48.39h-13.55l20.84-109.45ZM1245.81,1570.93h12.24c17.33,0,28.49-11.3,28.49-24.64,0-11.88-8.96-17.23-21.46-17.23-5.45,0-8.96.46-11.51,1.19l-7.75,40.68Z'
				className='shape'
			/>
			<path
				d='M1396.03,1581.57c0,24.62-17.48,50.18-44.28,50.18-19.96,0-31.12-14.8-31.12-32.73,0-26.33,18.28-50.6,44.21-50.6,21.5,0,31.2,16.26,31.2,33.15ZM1334.73,1598.48c0,12.95,7.2,22.44,18.89,22.44,16.08,0,28.29-20.85,28.29-39.38,0-9.31-4.3-22.29-18.58-22.29-17.23,0-28.62,20.96-28.61,39.23Z'
				className='shape'
			/>
			<path
				d='M1474.07,1626.78c-4.08,2.02-12.33,4.89-23.16,4.89-20.51,0-30.66-13.9-30.66-30.83,0-27.2,20.24-52.39,48.89-52.39,7.43,0,14.14,2.17,16.56,3.62l-3.91,10.84c-3.17-1.51-7.54-3.01-13.54-3.01-20.69,0-33.79,20.41-33.79,39.2,0,12.96,6.78,21.32,19.85,21.32,8.1,0,14.34-2.49,18.42-4.44l1.32,10.8Z'
				className='shape'
			/>
			<path
				d='M1502.16,1629.94l22.24-117.02h13.59l-14,73.36h.33c2.43-2.79,5.37-5.84,7.46-8.03l28.09-28.02h16.89l-34.78,32.72,23.8,46.98h-15.05l-19.19-39.34-10.09,9-5.73,30.34h-13.56Z'
				className='shape'
			/>
			<path
				d='M1609.19,1550.23l7.89,42.87c1.77,9.17,2.81,15.06,3.6,21.01h.42c2.1-5.11,4.44-10.7,8.46-19.52l20.41-44.36h14.52l-29.94,60.58c-8.55,17.27-16.63,31.27-27.48,41.94-8.91,8.97-18.64,12.78-23.19,13.76l-3.34-11.74c3.42-1.2,9.21-3.43,14.6-7.67,5.39-4.16,11.14-10.59,15.41-18.39.7-1.31.64-2.23.4-3.62l-15.98-74.85h14.21Z'
				className='shape'
			/>
			<path
				d='M1814.34,1629.94l7.96-59.98c1.44-10.59,3.9-26.86,6.02-37.59h-.53c-5.13,11.21-11.32,24.43-17.38,35.79l-33,61.09h-10.45l-8.21-59.84c-1.7-12.76-2.82-25.65-3.58-37.04h-.36c-2.35,10.26-5.82,27.04-8.47,37.62l-15.11,59.96h-12.86l28.76-111.08h17.44l8.8,63.7c1.1,9.44,2.38,19.59,2.68,27.85h.5c3.38-8.26,8.14-18.22,12.93-27.46l34.39-64.09h17.88l-14.1,111.08h-13.3Z'
				className='shape'
			/>
			<path
				d='M1939.04,1581.57c0,24.62-17.48,50.18-44.28,50.18-19.96,0-31.12-14.8-31.12-32.73,0-26.33,18.28-50.6,44.21-50.6,21.5,0,31.2,16.26,31.2,33.15ZM1877.75,1598.48c0,12.95,7.2,22.44,18.89,22.44,16.08,0,28.29-20.85,28.29-39.38,0-9.31-4.3-22.29-18.58-22.29-17.23,0-28.62,20.96-28.61,39.23Z'
				className='shape'
			/>
			<path
				d='M2039.51,1550.23l-10.74,56.51c-1.68,8.87-2.8,16.59-3.56,23.2h-12.33l2.07-15.04-.33-.02c-7.11,10.4-17.59,16.88-28.12,16.88s-21.05-4.94-21.05-23.08c0-3.83.49-8.14,1.53-13.42l8.62-45.02h13.64l-8.47,44.43c-.85,4.43-1.36,8.26-1.36,11.69,0,8.24,3.38,13.87,12.74,13.87,9.96,0,22.66-11.62,25.97-29.12l7.77-40.87h13.64Z'
				className='shape'
			/>
			<path
				d='M2061.63,1629.94l10.66-56.51c1.77-8.86,2.86-16.59,3.76-23.2h12.28l-2.05,15.66h.33c7.17-11.21,17.89-17.47,29.56-17.47,9.46,0,20.15,5.46,20.15,22.13,0,3.55-.64,8.6-1.42,12.86l-8.85,46.52h-13.64l8.71-46.05c.55-3.09,1.08-6.81,1.08-10.2,0-8-3.08-13.89-12.49-13.89s-23.64,11.68-27.26,31.39l-7.19,38.75h-13.64Z'
				className='shape'
			/>
			<path
				d='M2198.5,1528.81l-4.1,21.42h19.05l-2.13,10.7h-19.06l-7.34,38.75c-.86,4.45-1.58,8.57-1.58,12.72,0,4.77,2.26,7.73,7.54,7.73,2.46,0,4.66-.17,6.44-.64l-.66,10.75c-2.43.93-6.59,1.45-10.57,1.45-12.05,0-16.78-7.31-16.78-15.46,0-4.64.58-9.19,1.75-14.96l7.78-40.34h-11.4l2.07-10.7h11.44l3.36-17.96,14.19-3.46Z'
				className='shape'
			/>
			<path
				d='M2280.28,1629.94c-.06-4.8.75-12.34,1.78-20.59h-.35c-8.61,16.55-19.61,22.41-30.86,22.41-14.12,0-22.92-11.22-22.92-26.34,0-27.77,20.43-56.99,55.1-56.99,7.64,0,15.98,1.31,21.51,3.02l-8.13,41.55c-2.64,13.87-3.74,28.12-3.37,36.95h-12.75ZM2289.14,1560.43c-1.92-.62-4.87-1.13-9.48-1.13-20.64,0-37.48,21.47-37.57,43.65-.06,8.91,3.08,17.59,13.61,17.59,11.44,0,24.84-14.86,28.81-36.05l4.63-24.05Z'
				className='shape'
			/>
			<path
				d='M2326.96,1629.94l15.22-79.7h13.64l-15.22,79.7h-13.64ZM2344.71,1527.98c.06-5.27,4.05-9.25,8.99-9.25s8.14,3.59,8.14,8.58c-.17,5.39-4,9.2-9.27,9.2-4.82,0-7.95-3.68-7.86-8.53Z'
				className='shape'
			/>
			<path
				d='M2377.89,1629.94l10.66-56.51c1.77-8.86,2.86-16.59,3.76-23.2h12.28l-2.05,15.66h.33c7.17-11.21,17.89-17.47,29.56-17.47,9.46,0,20.15,5.46,20.15,22.13,0,3.55-.64,8.6-1.42,12.86l-8.85,46.52h-13.64l8.71-46.05c.55-3.09,1.08-6.81,1.08-10.2,0-8-3.08-13.89-12.49-13.89s-23.64,11.68-27.26,31.39l-7.19,38.75h-13.64Z'
				className='shape'
			/>
			<path
				d='M2479.74,1616.09c3.76,2.25,10.58,4.97,17.14,4.96,9.2-.01,15.17-5.95,15.17-13.01,0-6.22-2.8-10.12-11.07-14.7-9.23-5.1-14.41-12.15-14.41-20.32,0-13.92,12.08-24.59,28.89-24.59,7.23,0,13.61,1.94,16.59,3.96l-3.83,10.32c-2.75-1.59-7.79-3.63-13.74-3.63-8.34,0-14.22,5.19-14.22,11.97,0,5.87,3.83,9.41,10.95,13.42,8.88,5.02,14.88,11.98,14.88,20.94,0,16.75-13.62,26.27-30.44,26.27-8.57,0-16.21-2.7-19.83-5.46l3.91-10.11Z'
				className='shape'
			/>
			<rect
				x='3627.19'
				y='1528.16'
				width='669.08'
				height='222.77'
				fill='none'
				className='shape'
			/>
			<path
				d='M3725.38,1698.05l7.96-59.98c1.44-10.59,3.9-26.86,6.02-37.59h-.53c-5.13,11.21-11.32,24.43-17.38,35.79l-33,61.09h-10.45l-8.21-59.84c-1.7-12.76-2.82-25.65-3.58-37.04h-.36c-2.35,10.26-5.82,27.04-8.47,37.62l-15.11,59.96h-12.86l28.76-111.08h17.44l8.8,63.7c1.1,9.44,2.38,19.59,2.68,27.85h.5c3.38-8.26,8.14-18.22,12.93-27.46l34.39-64.09h17.88l-14.1,111.08h-13.3Z'
				className='shape'
			/>
			<path
				d='M3774.59,1698.05l15.22-79.7h13.64l-15.22,79.7h-13.64ZM3792.34,1596.09c.06-5.27,4.05-9.25,8.99-9.25s8.14,3.59,8.14,8.58c-.17,5.39-4,9.2-9.27,9.2-4.82,0-7.95-3.68-7.86-8.53Z'
				className='shape'
			/>
			<path
				d='M3910.28,1581.04l-17.49,91.75c-1.54,8.26-2.89,17.56-3.36,25.27h-12.52l2.12-15.77h-.33c-7.28,11.3-17.3,17.58-28.75,17.58-15.37,0-23.81-12.63-23.81-29.01,0-28.34,21.06-54.32,49.31-54.32,5,0,10.63,1.07,14.08,2.73l7.15-38.23h13.6ZM3887.34,1630.83c-2.76-1.87-7.32-3.39-13.04-3.39-19.13,0-34,20.37-34,41.54,0,9.65,3.29,19.66,15.04,19.66,10.49,0,23.24-12.01,26.66-29.95l5.33-27.87Z'
				className='shape'
			/>
			<path
				d='M3944.26,1618.35l2.81,44.82c.61,9.85.56,14.96.38,21.44h.37c1.91-5.2,4.79-12.04,8.75-20.01l23.72-46.26h11.9l5.04,45.41c.81,8.77,1.35,15.56,1.26,20.85h.4c2.12-6.42,4.3-12.59,7.53-20.22l21.52-46.04h13.92l-39.39,79.7h-12.69l-5.27-43.3c-.79-7.39-1.22-14.18-1.16-21.22h-.34c-3.34,7.68-5.63,13.74-9.25,20.81l-22.86,43.71h-12.78l-7.35-79.7h13.49Z'
				className='shape'
			/>
			<path
				d='M4111.24,1693.49c-6.03,3.39-15.66,6.3-26.35,6.3-21.18,0-30.32-14.43-30.32-32.07,0-24,17.83-51.18,43.49-51.18,15.16,0,23.39,9.04,23.41,20.45,0,20.93-23.59,26.45-53.05,25.89-.67,3.45-.2,10.89,1.61,15.17,3.21,7.18,9.53,10.71,17.73,10.71,9.48,0,16.59-2.82,21.47-5.46l2.01,10.19ZM4096.13,1627.17c-13.02,0-22.85,12.71-26.18,25.19,21.48.25,38.3-2.61,38.3-15.03,0-6.56-5-10.15-12.12-10.15Z'
				className='shape'
			/>
			<path
				d='M4142.26,1684.21c3.76,2.25,10.58,4.97,17.14,4.96,9.2-.01,15.17-5.95,15.17-13.01,0-6.22-2.8-10.12-11.07-14.7-9.23-5.1-14.41-12.15-14.41-20.32,0-13.92,12.08-24.59,28.89-24.59,7.23,0,13.61,1.94,16.59,3.96l-3.83,10.32c-2.75-1.59-7.79-3.63-13.74-3.63-8.34,0-14.22,5.19-14.22,11.97,0,5.87,3.83,9.41,10.95,13.42,8.88,5.02,14.88,11.98,14.88,20.94,0,16.75-13.62,26.27-30.44,26.27-8.57,0-16.21-2.7-19.83-5.46l3.91-10.11Z'
				className='shape'
			/>
			<path
				d='M4251.93,1596.93l-4.1,21.42h19.05l-2.13,10.7h-19.06l-7.34,38.75c-.87,4.45-1.58,8.57-1.58,12.72,0,4.77,2.26,7.73,7.54,7.73,2.46,0,4.66-.17,6.44-.64l-.66,10.75c-2.43.93-6.59,1.45-10.57,1.45-12.05,0-16.78-7.31-16.78-15.46,0-4.64.58-9.19,1.75-14.96l7.78-40.34h-11.4l2.07-10.7h11.44l3.36-17.96,14.19-3.46Z'
				className='shape'
			/>
			<rect
				x='4781.39'
				y='2892.74'
				width='791.58'
				height='222.77'
				fill='none'
				className='shape'
			/>
			<path
				d='M4788.24,3045.45c6.04,4.07,14.36,7.09,23.64,7.09,12.5.02,24.01-7.46,24.01-20.86,0-8.26-4.66-14.4-16.25-20.77-14.18-7.67-22.11-16.56-22.11-28.49,0-19.88,17.08-32.61,37.5-32.61,10.85,0,18.93,3.15,22.75,5.78l-4.85,11.17c-3.49-2.1-10.43-5.29-19.27-5.22-13.72,0-22,9.04-22.03,18.16,0,9.01,5.63,14.14,17.25,20.59,13.69,7.33,21.19,16.09,21.19,29.73,0,19.21-15.08,34.34-40.08,34.34-11.11,0-22.08-3.63-26.72-7.72l4.95-11.19Z'
				className='shape'
			/>
			<path
				d='M4954.19,3014.26c0,24.62-17.48,50.18-44.28,50.18-19.96,0-31.12-14.8-31.12-32.73,0-26.33,18.28-50.6,44.21-50.6,21.5,0,31.2,16.26,31.2,33.15ZM4892.89,3031.17c0,12.95,7.2,22.44,18.89,22.44,16.08,0,28.29-20.85,28.29-39.38,0-9.31-4.3-22.29-18.58-22.29-17.22,0-28.62,20.96-28.61,39.23Z'
				className='shape'
			/>
			<path
				d='M5054.65,2982.92l-10.74,56.51c-1.68,8.86-2.8,16.59-3.56,23.2h-12.33l2.07-15.04-.33-.02c-7.1,10.4-17.59,16.88-28.12,16.88s-21.05-4.94-21.05-23.08c0-3.83.49-8.14,1.53-13.42l8.62-45.02h13.64l-8.47,44.43c-.85,4.43-1.36,8.26-1.36,11.69,0,8.24,3.38,13.87,12.74,13.87,9.96,0,22.66-11.62,25.97-29.12l7.77-40.87h13.64Z'
				className='shape'
			/>
			<path
				d='M5112.45,2961.5l-4.1,21.42h19.05l-2.13,10.7h-19.06l-7.34,38.75c-.87,4.45-1.58,8.57-1.58,12.72,0,4.77,2.26,7.73,7.54,7.73,2.46,0,4.66-.17,6.44-.64l-.66,10.75c-2.43.93-6.59,1.45-10.57,1.45-12.05,0-16.78-7.31-16.78-15.46,0-4.64.58-9.19,1.75-14.96l7.78-40.34h-11.4l2.07-10.7h11.44l3.36-17.96,14.19-3.46Z'
				className='shape'
			/>
			<path
				d='M5141.54,3062.63l22.24-117.02h13.67l-9.96,51.36h.33c6.84-9.69,16.45-15.86,28.48-15.86,9.05,0,19.84,5.47,19.84,21.35,0,4.26-.53,9.44-1.32,13.49l-8.87,46.68h-13.64l8.75-46.05c.56-2.91,1.08-6.59,1.08-11,0-7.33-3.52-13.09-12.38-13.09-10.58,0-23.82,12.37-27.15,30.21l-7.43,39.93h-13.64Z'
				className='shape'
			/>
			<path
				d='M5300.21,3058.06c-6.03,3.39-15.66,6.3-26.35,6.3-21.18,0-30.32-14.43-30.32-32.07,0-24,17.83-51.18,43.49-51.18,15.16,0,23.39,9.04,23.41,20.45,0,20.93-23.59,26.45-53.05,25.89-.67,3.46-.2,10.89,1.61,15.17,3.21,7.18,9.53,10.71,17.73,10.71,9.48,0,16.59-2.82,21.47-5.46l2.01,10.19ZM5285.1,2991.74c-13.02,0-22.85,12.71-26.18,25.19,21.48.25,38.3-2.61,38.3-15.03,0-6.56-5-10.15-12.12-10.15Z'
				className='shape'
			/>
			<path
				d='M5383.42,3062.63c-.06-4.8.75-12.34,1.78-20.59h-.35c-8.61,16.55-19.61,22.41-30.86,22.41-14.12,0-22.92-11.22-22.92-26.34,0-27.77,20.43-56.99,55.1-56.99,7.64,0,15.98,1.31,21.51,3.02l-8.13,41.55c-2.64,13.87-3.74,28.12-3.37,36.95h-12.75ZM5392.29,2993.12c-1.92-.62-4.87-1.13-9.48-1.13-20.64,0-37.48,21.47-37.57,43.65-.06,8.91,3.08,17.59,13.61,17.59,11.44,0,24.84-14.86,28.81-36.05l4.63-24.05Z'
				className='shape'
			/>
			<path
				d='M5430.77,3048.78c3.76,2.25,10.58,4.97,17.14,4.96,9.2-.01,15.17-5.95,15.17-13.01,0-6.22-2.8-10.12-11.07-14.7-9.23-5.1-14.41-12.15-14.41-20.32,0-13.92,12.08-24.59,28.89-24.59,7.23,0,13.61,1.94,16.59,3.96l-3.83,10.32c-2.75-1.59-7.79-3.63-13.74-3.63-8.34,0-14.22,5.19-14.22,11.97,0,5.87,3.83,9.41,10.95,13.42,8.88,5.02,14.88,11.98,14.88,20.94,0,16.75-13.62,26.27-30.44,26.27-8.57,0-16.21-2.7-19.83-5.46l3.91-10.11Z'
				className='shape'
			/>
			<path
				d='M5540.44,2961.5l-4.1,21.42h19.05l-2.13,10.7h-19.06l-7.34,38.75c-.87,4.45-1.58,8.57-1.58,12.72,0,4.77,2.26,7.73,7.54,7.73,2.46,0,4.66-.17,6.44-.64l-.66,10.75c-2.43.93-6.59,1.45-10.57,1.45-12.05,0-16.78-7.31-16.78-15.46,0-4.64.58-9.19,1.75-14.96l7.78-40.34h-11.4l2.07-10.7h11.44l3.36-17.96,14.19-3.46Z'
				className='shape'
			/>
			<rect
				x='5996.41'
				y='1479.82'
				width='791.58'
				height='222.77'
				fill='none'
				className='shape'
			/>
			<path
				d='M6001.55,1649.71l21.13-111.08h14.96l25.44,62.89c4.92,12.63,7.42,21.43,9.75,30.98l.37-.17c.6-9.97,1.76-19.2,4.65-34.77l11.21-58.93h12.92l-21.13,111.08h-13.5l-25.32-62.79c-5.42-13.74-7.89-21.53-10.31-32.05l-.49.17c-1.22,10.38-2.99,21.49-5.83,36.6l-10.97,58.07h-12.89Z'
				className='shape'
			/>
			<path
				d='M6194.91,1601.34c0,24.62-17.48,50.18-44.28,50.18-19.96,0-31.12-14.8-31.12-32.73,0-26.33,18.28-50.6,44.21-50.6,21.5,0,31.2,16.26,31.2,33.15ZM6133.62,1618.26c0,12.95,7.2,22.44,18.89,22.44,16.08,0,28.29-20.85,28.29-39.38,0-9.31-4.3-22.29-18.58-22.29-17.22,0-28.62,20.96-28.61,39.23Z'
				className='shape'
			/>
			<path
				d='M6217.64,1649.71l9.74-51.34c1.96-10.39,3.16-20.97,4.05-28.36h12.04c-.65,5.54-1.29,11.11-2.22,17.32h.48c5.23-10.92,13.74-19.13,24.43-19.13,1.26,0,2.84.1,3.91.3l-2.66,13.49c-.96-.19-2.17-.28-3.72-.28-11.83,0-22.37,14.34-25.82,32.85l-6.59,35.16h-13.64Z'
				className='shape'
			/>
			<path
				d='M6323.19,1548.59l-4.1,21.42h19.05l-2.13,10.7h-19.06l-7.34,38.75c-.87,4.45-1.58,8.57-1.58,12.72,0,4.77,2.26,7.73,7.54,7.73,2.46,0,4.66-.17,6.44-.64l-.66,10.75c-2.43.93-6.59,1.45-10.57,1.45-12.05,0-16.78-7.31-16.78-15.46,0-4.64.58-9.19,1.75-14.96l7.78-40.34h-11.4l2.07-10.7h11.44l3.36-17.96,14.19-3.46Z'
				className='shape'
			/>
			<path
				d='M6352.27,1649.71l22.24-117.02h13.67l-9.96,51.36h.33c6.84-9.69,16.45-15.86,28.48-15.86,9.05,0,19.84,5.47,19.84,21.35,0,4.26-.53,9.44-1.32,13.49l-8.87,46.68h-13.64l8.75-46.05c.56-2.91,1.08-6.59,1.08-11,0-7.33-3.52-13.09-12.38-13.09-10.58,0-23.82,12.37-27.15,30.21l-7.43,39.93h-13.64Z'
				className='shape'
			/>
			<path
				d='M6510.95,1645.14c-6.03,3.39-15.66,6.3-26.35,6.3-21.18,0-30.32-14.43-30.32-32.07,0-24,17.83-51.18,43.49-51.18,15.16,0,23.39,9.04,23.41,20.45,0,20.93-23.59,26.45-53.05,25.89-.67,3.45-.2,10.89,1.61,15.17,3.21,7.18,9.53,10.71,17.73,10.71,9.48,0,16.59-2.82,21.47-5.46l2.01,10.19ZM6495.83,1578.83c-13.02,0-22.85,12.71-26.18,25.19,21.48.25,38.3-2.61,38.3-15.03,0-6.56-5-10.15-12.12-10.15Z'
				className='shape'
			/>
			<path
				d='M6594.15,1649.71c-.06-4.8.75-12.34,1.78-20.59h-.35c-8.61,16.55-19.61,22.41-30.86,22.41-14.12,0-22.92-11.22-22.92-26.34,0-27.77,20.43-56.99,55.1-56.99,7.64,0,15.98,1.31,21.51,3.02l-8.13,41.55c-2.64,13.87-3.74,28.12-3.37,36.95h-12.75ZM6603.02,1580.21c-1.92-.62-4.87-1.13-9.48-1.13-20.64,0-37.48,21.47-37.57,43.65-.06,8.91,3.08,17.59,13.61,17.59,11.44,0,24.84-14.86,28.81-36.05l4.63-24.05Z'
				className='shape'
			/>
			<path
				d='M6641.5,1635.86c3.76,2.25,10.58,4.97,17.14,4.96,9.2-.01,15.17-5.95,15.17-13.01,0-6.22-2.8-10.12-11.07-14.7-9.23-5.1-14.41-12.15-14.41-20.32,0-13.92,12.08-24.59,28.89-24.59,7.23,0,13.61,1.94,16.59,3.96l-3.83,10.32c-2.75-1.59-7.79-3.63-13.74-3.63-8.34,0-14.22,5.19-14.22,11.97,0,5.87,3.83,9.41,10.95,13.42,8.88,5.02,14.88,11.98,14.88,20.94,0,16.75-13.62,26.27-30.44,26.27-8.57,0-16.21-2.7-19.83-5.46l3.91-10.11Z'
				className='shape'
			/>
			<path
				d='M6751.17,1548.59l-4.1,21.42h19.05l-2.13,10.7h-19.06l-7.34,38.75c-.87,4.45-1.58,8.57-1.58,12.72,0,4.77,2.26,7.73,7.54,7.73,2.46,0,4.66-.17,6.44-.64l-.66,10.75c-2.43.93-6.59,1.45-10.57,1.45-12.05,0-16.78-7.31-16.78-15.46,0-4.64.58-9.19,1.75-14.96l7.78-40.34h-11.4l2.07-10.7h11.44l3.36-17.96,14.19-3.46Z'
				className='shape'
			/>
		</svg>
	);
};

CountryMap.propTypes = {
	onRegionClick: PropTypes.func.isRequired,
	selectedRegion: PropTypes.string,
};

export default CountryMap;
